var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuropaBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Thu Oct  3 04:05:00 2013\n By ,,,\nCopyright (c) 2011 Fabian Leuenberger and EuropaType. All rights reserved. This Font Software may not be reproduced, modified, disclosed or transferred without the express written approval of EuropaType. EUROPA is a trademark of EuropaType and may be registered in certain jurisdictions. This Font Software is original artwork of Fabian Leuenberger and EuropaType. The design may be protected in certain jurisdictions.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Europa-Bold",
    horizAdvX: 580
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Europa-Bold",
    fontWeight: 700,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 0 0 0 0 0 0 0 0 0",
    ascent: 782,
    descent: -218,
    xHeight: 474,
    capHeight: 700,
    bbox: "-180 -276 1062 1033",
    underlineThickness: 38,
    underlinePosition: -153,
    unicodeRange: "U+0020-FB04"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 600,
    d: "M36 0v700h528v-700h-528zM111 628v-556h378v556h-378zM347 432q0 19 -14.5 32t-34.5 13q-21 0 -36.5 -12.5t-21.5 -24.5l-5 -13l-55 25q1 4 3.5 9.5t12 20.5t21.5 26.5t33.5 21t47.5 9.5q48 0 80.5 -31t32.5 -76q0 -32 -14 -52.5t-45 -46.5q-14 -13 -16.5 -18t-2.5 -20 v-31h-65v44q0 6 0.5 10.5t2 9t2 7.5t4 7t5 6t7 7t7.5 7t10 8t11 9q17 15 23.5 25.5t6.5 27.5zM260 192q0 16 12 28t28 12q17 0 29.5 -12t12.5 -28q0 -17 -12.5 -29t-29.5 -12t-28.5 12t-11.5 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffj",
    unicode: "ffj",
    horizAdvX: 860,
    d: "M16 368v106h94v111q0 85 57 134t144 49q84 0 139 -45q56 45 139 45q92 0 144.5 -49.5t52.5 -117.5v-11q0 -25 -18 -42t-43 -17t-42 17t-17 42v7q0 28 -21.5 45.5t-55.5 17.5q-33 0 -57 -22t-24 -63v-101h92v-106h-92v-368h-120v597q0 28 -21.5 45.5t-55.5 17.5 q-33 0 -57 -22t-24 -63v-101h97v-106h-97v-368h-120v368h-94zM498 -211l44 100q27 -19 49 -19q15 0 25.5 2.5t23.5 11.5t19.5 30t6.5 54v506h120v-517q0 -55 -17 -96t-44.5 -62t-56.5 -31t-58 -10q-60 0 -112 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fft",
    unicode: "fft",
    horizAdvX: 1001,
    d: "M222 572v-98h192v112q0 94 52 138t120 44q29 0 57 -7t41 -14l13 -7l-45 -101q-20 17 -54 17q-27 0 -45.5 -20.5t-18.5 -63.5v-98h166v129h120v-129h143v-106h-143v-193q0 -75 63 -75q12 0 24.5 4t18.5 8l7 5l43 -98q-45 -31 -114 -31q-71 0 -116.5 44.5t-45.5 121.5v214 h-166v-368h-120v368h-192v-368h-120v368h-86v106h86v112q0 94 52 138t120 44q29 0 57 -7t41 -14l13 -7l-45 -101q-20 17 -54 17q-27 0 -45.5 -20.5t-18.5 -63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ff",
    unicode: "ff",
    horizAdvX: 691,
    d: "M230 572v-98h192v112q0 94 52 138t120 44q29 0 57 -7t41 -14l13 -7l-45 -101q-20 17 -54 17q-27 0 -45.5 -20.5t-18.5 -63.5v-98h120v-106h-120v-368h-120v368h-192v-368h-120v368h-94v106h94v112q0 94 52 138t120 44q29 0 57 -7t41 -14l13 -7l-45 -101q-20 17 -54 17 q-27 0 -45.5 -20.5t-18.5 -63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 582,
    d: "M16 368v106h94v111q0 85 57 134t144 49q92 0 144.5 -49.5t52.5 -117.5v-11q0 -25 -18 -42t-43 -17t-42 17t-17 42v7q0 28 -21.5 45.5t-55.5 17.5q-33 0 -57 -22t-24 -63v-101h97v-106h-97v-368h-120v368h-94zM388 0v474h120v-474h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 583,
    d: "M389 0v575q0 41 -22.5 63t-55.5 22t-57.5 -22t-24.5 -63v-101h97v-106h-97v-368h-120v368h-93v106h93v111q0 85 57.5 134t144.5 49t142.5 -49t55.5 -134v-585h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffi",
    unicode: "ffi",
    horizAdvX: 860,
    d: "M388 0v590v7q0 28 -21.5 45.5t-55.5 17.5q-33 0 -57 -22t-24 -63v-101h95v-106h-95v-368h-120v368h-94v106h94v111q0 85 57 134t144 49t139 -44q53 44 139 44q92 0 144.5 -49.5t52.5 -117.5v-11q0 -25 -18 -42t-43 -17t-42 17t-17 42v7q0 28 -21.5 45.5t-55.5 17.5 q-33 0 -57 -22t-24 -63v-101h95v-106h-95v-368h-120zM666 0v474h120v-474h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffl",
    unicode: "ffl",
    horizAdvX: 853,
    d: "M659 0v575q0 41 -22.5 63t-55.5 22t-57.5 -22t-24.5 -63v-101h97v-106h-97v-368h-120v368h-158v-368h-120v368h-85v106h85v111q0 85 57 134t144 49q86 0 138 -44q53 44 141 44q87 0 142.5 -49t55.5 -134v-585h-120zM221 474h158v123q0 28 -21.5 45.5t-55.5 17.5 q-33 0 -57 -22t-24 -63v-101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 600,
    d: "M36 0v700h528v-700h-528zM111 628v-556h378v556h-378zM347 432q0 19 -14.5 32t-34.5 13q-21 0 -36.5 -12.5t-21.5 -24.5l-5 -13l-55 25q1 4 3.5 9.5t12 20.5t21.5 26.5t33.5 21t47.5 9.5q48 0 80.5 -31t32.5 -76q0 -32 -14 -52.5t-45 -46.5q-14 -13 -16.5 -18t-2.5 -20 v-31h-65v44q0 6 0.5 10.5t2 9t2 7.5t4 7t5 6t7 7t7.5 7t10 8t11 9q17 15 23.5 25.5t6.5 27.5zM260 192q0 16 12 28t28 12q17 0 29.5 -12t12.5 -28q0 -17 -12.5 -29t-29.5 -12t-28.5 12t-11.5 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 294
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 306,
    d: "M215 700l-5 -500h-114l-5 500h124zM74 67q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 400,
    d: "M60 452v248h106v-248h-106zM234 452v248h106v-248h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 634,
    d: "M69 418v88h129l30 211l87 -12l-28 -199h109l30 211l87 -12l-28 -199h117v-88h-129l-17 -120h116v-88h-128l-32 -227l-88 12l30 215h-108l-32 -227l-88 12l30 215h-117v88h130l17 120h-117zM275 418l-17 -120h109l17 120h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    d: "M271 -94v83q-43 4 -83 19.5t-65.5 35.5t-45 39.5t-27.5 32.5l-9 13l93 74q2 -3 5.5 -9t17 -22t28 -28.5t38 -25t48.5 -16.5v199q-42 15 -73.5 32t-62 42t-47 60.5t-16.5 78.5q0 72 54.5 129.5t144.5 66.5v84h63v-84q54 -6 101.5 -31.5t68.5 -48.5l20 -22l-90 -75 q-4 5 -12 14t-34 26t-54 23v-196q3 -2 11 -4q46 -17 77 -33t61 -40.5t44.5 -59.5t14.5 -80q0 -83 -58.5 -133.5t-149.5 -59.5v-84h-63zM420 183q0 34 -21 55t-65 40v-175q37 6 61.5 26.5t24.5 53.5zM194 514q0 -31 18.5 -51t58.5 -38v171q-35 -8 -56 -30.5t-21 -51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 712,
    d: "M184 712q67 0 114.5 -46.5t47.5 -112.5t-47.5 -112.5t-114.5 -46.5t-114.5 46.5t-47.5 112.5t47.5 112.5t114.5 46.5zM184 471q35 0 58 23.5t23 58.5t-23 58.5t-58 23.5q-36 0 -59 -23.5t-23 -58.5t23 -58.5t59 -23.5zM528 306q67 0 114.5 -46.5t47.5 -112.5 t-47.5 -112.5t-114.5 -46.5t-114.5 46.5t-47.5 112.5t47.5 112.5t114.5 46.5zM528 65q35 0 58 23.5t23 58.5t-23 58.5t-58 23.5q-36 0 -59 -23.5t-23 -58.5t23 -58.5t59 -23.5zM89 7l471 724l57 -39l-471 -724z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 695,
    d: "M507 384h115q0 -69 -10 -122.5t-20 -72.5l-11 -19l114 -100l-70 -82l-107 95q-38 -43 -99 -69t-132 -26q-100 0 -166.5 56t-66.5 126q0 52 28.5 95t109.5 104q-98 90 -98 164t54 126.5t137 52.5t137 -52.5t54 -126.5q0 -43 -23.5 -79t-89.5 -92l129 -114q15 22 15 136z M287 98q88 0 147 59l-159 139q-67 -57 -84 -76.5t-17 -42.5q0 -36 34 -57.5t79 -21.5zM210 533q0 -5 1 -10t2 -9.5t4 -9.5t5 -8.5t7 -9.5l7.5 -9t9.5 -10t10.5 -10t12.5 -11.5t13 -12.5q47 40 62 60.5t15 39.5q0 30 -23 49.5t-51 19.5q-30 0 -52.5 -19.5t-22.5 -49.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 186,
    d: "M40 454v246h106v-246h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 312,
    d: "M166 295q0 -66 13 -132t32 -113t38 -84.5t32 -56.5l13 -19l-98 -60q-6 8 -16 22.5t-35.5 63t-45 99.5t-35.5 127.5t-16 152.5t15 151.5t37 129.5t44 97t37 65l15 21l98 -59q-5 -7 -13.5 -19.5t-31 -54.5t-39 -86.5t-30.5 -111.5t-14 -133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 312,
    d: "M146 295q0 66 -13 132t-32 113t-38 84.5t-32 56.5l-13 19l98 59q6 -8 16 -22.5t35.5 -62.5t45 -99t35.5 -127.5t16 -152.5t-15 -151.5t-37 -129.5t-44 -97.5t-37 -64.5l-15 -22l-98 60q5 7 13.5 19.5t31 54.5t39 86.5t30.5 111.5t14 133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 398,
    d: "M199 453l-74 -105l-69 49l77 105l-127 40l27 79l124 -41v132h84v-132l124 41l27 -79l-127 -40l77 -105l-69 -49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 520,
    d: "M497 302v-112h-177v-190h-120v190h-177v112h177v184h120v-184h177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 241,
    d: "M99 97l100 -35l-87 -233l-92 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 333,
    d: "M33 190v114h267v-114h-267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 262,
    d: "M52 67q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 520,
    d: "M502 757l-400 -898l-96 43l400 898z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 606,
    d: "M304 712q65 0 116 -29.5t82 -80.5t47.5 -115t16.5 -137t-16.5 -137t-47.5 -115t-82 -80.5t-116 -29.5q-85 0 -146.5 51.5t-89.5 132t-28 178.5t28 178.5t89.5 132t146.5 51.5zM304 100q69 0 105.5 70.5t36.5 179.5t-36.5 179.5t-105.5 70.5q-70 0 -107 -70.5t-37 -179.5 t37 -179.5t107 -70.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 444,
    d: "M16 530l213 170h99v-700h-120v540l-123 -98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 555,
    d: "M40 0l257 326q3 3 18 21.5t22.5 30t19 31t16.5 40.5t5 43q0 44 -28.5 76t-75.5 32q-29 0 -52.5 -10.5t-36.5 -25.5t-21.5 -30t-11.5 -26l-3 -10l-107 39q2 7 6 19t22 42t41.5 53t67 42t95.5 19q108 0 166 -62.5t58 -155.5q0 -89 -61 -172l-161 -208h225v-114h-461z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 570,
    d: "M386 502q0 42 -29.5 70t-75.5 28q-25 0 -47 -9t-34.5 -21t-21.5 -24.5t-12 -21.5l-4 -9l-104 49q2 6 6.5 16t23 35.5t41.5 45t64 35.5t88 16q98 0 162 -57.5t64 -152.5q0 -28 -9 -53.5t-21.5 -41.5t-25 -28.5t-21.5 -18.5l-9 -5q4 -1 11 -3.5t25 -14.5t31.5 -28t24.5 -46 t11 -68q0 -93 -69 -150t-173 -57q-55 0 -100 16.5t-71 40.5t-43.5 48t-23.5 41l-7 16l98 57q1 -4 4 -11.5t14.5 -26t26.5 -32.5t42.5 -25.5t59.5 -11.5q56 0 89 27t33 68q0 51 -36.5 75t-90.5 24h-50v110h38q121 0 121 98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 593,
    d: "M-4 152l356 548h134v-436h77v-112h-77v-152h-120v152h-370zM192 264h176v271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 585,
    d: "M542 230q0 -115 -74.5 -178.5t-174.5 -63.5q-52 0 -96 16.5t-70.5 40.5t-45 48t-25.5 41l-8 16l100 57q1 -4 4.5 -11.5t15.5 -26t27 -32.5t41 -25.5t57 -11.5q59 0 93.5 37t34.5 93q0 59 -37 94.5t-112 35.5q-43 0 -90 -19t-72 -38l-26 -19v416h440v-114h-320v-137 q39 21 99 21q100 0 169.5 -62t69.5 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 564,
    d: "M398 670l-130 -211q13 3 24 3q108 0 172.5 -71t64.5 -166q0 -94 -68.5 -165.5t-176.5 -71.5t-176.5 71t-68.5 164q0 73 39 145l220 364zM284 350q-53 0 -88.5 -34.5t-35.5 -90.5t35.5 -90.5t88.5 -34.5t88.5 34.5t35.5 90.5t-35.5 90.5t-88.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 526,
    d: "M36 586v114h500l-375 -724l-102 53l288 557h-311z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 576,
    d: "M288 712q104 0 162 -59t58 -143q0 -41 -19.5 -75.5t-38.5 -48.5l-20 -14q4 -2 10.5 -5t23.5 -17t30 -31t23.5 -47t10.5 -66q0 -92 -65 -155t-175 -63t-175 63t-65 155q0 36 10 66t24.5 47.5t29 30t24.5 17.5l10 5q-3 2 -8.5 5.5t-19 16.5t-23.5 27.5t-18.5 38.5t-8.5 50 q0 84 58 143t162 59zM288 98q56 0 87.5 32t31.5 78t-31.5 77t-87.5 31t-87.5 -31t-31.5 -77t31.5 -78t87.5 -32zM389 509q0 42 -29 67.5t-72 25.5t-72 -25.5t-29 -67.5t29 -67.5t72 -25.5t72 25.5t29 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 564,
    d: "M168 34l128 207q-13 -3 -24 -3q-104 0 -170.5 71.5t-66.5 165.5t68.5 165.5t176.5 71.5t176.5 -71t68.5 -164q0 -69 -40 -145l-217 -360zM280 350q53 0 88.5 34.5t35.5 90.5t-35.5 90.5t-88.5 34.5t-88.5 -34.5t-35.5 -90.5t35.5 -90.5t88.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 274,
    d: "M58 67q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM58 407q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 243,
    d: "M42 406q0 33 23.5 56.5t55.5 23.5q33 0 56.5 -23.5t23.5 -56.5q0 -32 -23.5 -55.5t-56.5 -23.5q-32 0 -55.5 23.5t-23.5 55.5zM99 97l100 -35l-87 -233l-92 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 520,
    d: "M18 221v100l462 197v-123l-303 -124l303 -125v-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 520,
    d: "M45 116v110h430v-110h-430zM45 302v110h430v-110h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 520,
    d: "M506 321v-100l-462 -198v123l303 125l-303 124v123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 489,
    d: "M329 512q0 35 -27.5 60.5t-65.5 25.5t-67.5 -24t-40.5 -48l-10 -24l-102 47q2 7 6 18t22 39t40.5 49.5t63 39t88.5 17.5q90 0 151.5 -58t61.5 -142q0 -42 -16 -76.5t-35.5 -55t-59.5 -55.5q-27 -24 -32 -33t-5 -36v-51h-119v74q0 11 0.5 19.5t3.5 17.5t4.5 14.5t8 13.5 t9 12t12.5 13t14 12.5t18 15.5t20 17q32 28 44.5 47t12.5 51zM163 67q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 799,
    d: "M567 110l35 -75q-88 -47 -192 -47q-150 0 -256 106t-106 256t106 256t256 106q148 0 244.5 -101t96.5 -246q0 -63 -14.5 -108t-38 -66.5t-47 -30t-48.5 -8.5q-34 0 -63.5 17t-38.5 49l-5 -7.5t-14 -15.5t-24.5 -20t-35.5 -16t-46 -7q-55 0 -96 36t-41 93q0 53 43 89 t97 36q32 0 58.5 -8.5t36.5 -17.5l11 -8v17q0 38 -25.5 57.5t-58.5 19.5q-26 0 -52 -9t-39 -19l-13 -9l-40 72q7 5 20 13t51.5 21t75.5 13q74 0 120 -39.5t46 -105.5v-121q0 -52 36 -52q11 0 18.5 3t18 14t16 41t5.5 77q0 114 -70 188.5t-184 74.5q-116 0 -195.5 -80 t-79.5 -198q0 -117 79.5 -197.5t195.5 -80.5q85 0 157 38zM401 232q26 0 47 10t29 20l8 11v29q-25 28 -84 28q-34 0 -53 -13.5t-19 -35.5t19 -35.5t53 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 678,
    d: "M6 0l272 700h122l272 -700h-121l-64 166h-296l-64 -166h-121zM339 549l-105 -273h210z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 590,
    d: "M74 0v700h227q95 0 159 -48.5t64 -151.5q0 -38 -17 -69.5t-32.5 -44t-23.5 -15.5q5 -1 15.5 -5.5t27 -17t31 -29.5t25 -47t10.5 -65q0 -91 -67 -149t-167 -58h-252zM322 114q53 0 84.5 23t31.5 70t-31.5 70t-84.5 23h-128v-186h128zM194 414h103q105 0 105 86 q0 44 -29 65t-76 21h-103v-172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 676,
    d: "M389 100q34 0 66.5 9t53.5 21.5t37.5 25t23.5 21.5l8 9l80 -79q-4 -5 -11 -13t-32.5 -28.5t-54.5 -36t-75 -28.5t-96 -13q-152 0 -253.5 103.5t-101.5 258.5t101.5 258.5t253.5 103.5q47 0 91 -11.5t73 -27.5t51.5 -32t33.5 -27l10 -12l-81 -79q-3 3 -7.5 8.5t-22 18.5 t-36.5 23t-49.5 18.5t-62.5 8.5q-101 0 -167 -73t-66 -177t66 -177t167 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 680,
    d: "M300 700q152 0 249 -99t97 -251t-97 -251t-249 -99h-226v700h226zM302 114q99 0 160.5 69t61.5 167q0 99 -61.5 167.5t-160.5 68.5h-108v-472h108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 546,
    d: "M194 586v-170h280v-114h-280v-188h310v-114h-430v700h424v-114h-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 527,
    d: "M194 586v-171h275v-114h-275v-301h-120v700h415v-114h-295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 713,
    d: "M402 100q44 0 79.5 8.5t48.5 17.5l13 8v148h-159v112h277v-318q-4 -4 -11 -9.5t-31.5 -21t-52 -27t-72 -21t-92.5 -9.5q-155 0 -261.5 104t-106.5 258q0 155 104.5 258.5t258.5 103.5q48 0 92.5 -11t73.5 -26t51 -30.5t32 -26.5l10 -11l-82 -80q-2 3 -7 8t-21 17.5 t-35 22t-50 17.5t-64 8q-104 0 -172.5 -73.5t-68.5 -176.5t71 -176.5t175 -73.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 687,
    d: "M493 415v285h120v-700h-120v301h-299v-301h-120v700h120v-285h299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 296,
    d: "M88 0v700h120v-700h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 521,
    d: "M327 216v484h120v-480q0 -110 -63.5 -171t-175.5 -61q-39 0 -74.5 12t-58.5 29t-40 34.5t-25 29.5l-7 12l88 74q2 -3 5.5 -8.5t15 -18.5t24 -23t32.5 -18.5t40 -8.5q63 0 91 33.5t28 80.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 628,
    d: "M194 700v-314l250 314h150l-274 -344l308 -356h-159l-275 316v-316h-120v700h120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 500,
    d: "M74 0v700h120v-586h298v-114h-418z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 826,
    d: "M74 700h111l228 -352l228 352h111v-700h-120v470l-219 -333l-219 333v-470h-120v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 726,
    d: "M74 700h108l350 -482v482h120v-700h-108l-350 481v-481h-120v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 776,
    d: "M388 712q153 0 253.5 -103t100.5 -259t-100.5 -259t-253.5 -103t-253.5 103t-100.5 259t100.5 259t253.5 103zM388 102q103 0 167.5 72t64.5 176t-64.5 176t-167.5 72t-167.5 -72t-64.5 -176t64.5 -176t167.5 -72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 566,
    d: "M297 366q60 0 92.5 29.5t32.5 80.5t-32.5 80.5t-92.5 29.5h-103v-220h103zM74 0v700h238q103 0 167.5 -63.5t64.5 -160.5t-64.5 -160.5t-167.5 -63.5h-118v-252h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 791,
    d: "M388 712q153 0 253.5 -103t100.5 -259q0 -117 -62 -211l99 -85l-77 -88l-103 89q-90 -67 -211 -67q-153 0 -253.5 103t-100.5 259t100.5 259t253.5 103zM387 240l77 87l124 -108q32 58 32 131q0 104 -64.5 176t-167.5 72t-167.5 -72t-64.5 -176t64.5 -176t167.5 -72 q66 0 120 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 583,
    d: "M74 0v700h230q104 0 168 -61t64 -157q0 -80 -41 -135.5t-115 -74.5l175 -272h-140l-166 264h-55v-264h-120zM289 378q59 0 92 26.5t33 77.5t-33 77.5t-92 26.5h-95v-208h95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 595,
    d: "M424 183q0 41 -29 62.5t-99 46.5q-45 16 -78.5 32.5t-68.5 42.5t-53.5 63.5t-18.5 83.5q0 78 64 138t165 60q41 0 79.5 -11.5t64 -28t45.5 -32.5t29 -28l10 -11l-83 -82q-2 3 -6.5 8.5t-19.5 19t-30.5 24t-40 19t-48.5 8.5q-45 0 -76 -24.5t-31 -59.5q0 -28 20.5 -49.5 t41.5 -31t82 -32.5q5 -2 7 -3q46 -17 77 -33t60.5 -41t44 -60t14.5 -81q0 -92 -70 -143.5t-174 -51.5q-49 0 -93.5 14.5t-72.5 35.5t-49.5 42.5t-30.5 35.5l-10 15l90 76q2 -4 7 -11t21 -25.5t34 -32t46 -25t58 -11.5q50 0 86 20.5t36 60.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 534,
    d: "M207 0v586h-193v114h506v-114h-193v-586h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 688,
    d: "M494 269v431h120v-446q0 -117 -74 -191.5t-196 -74.5t-196 74.5t-74 191.5v446h120v-431q0 -77 38.5 -122t111.5 -45t111.5 45t38.5 122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 630,
    d: "M628 700l-313 -724l-313 724h131l186 -449l184 449h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 983,
    d: "M979 700l-276 -724l-210 525l-213 -525l-276 724h136l148 -420l159 420h99l156 -420l152 420h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 612,
    d: "M457 0l-157 264l-153 -264h-135l226 362l-212 338h142l143 -242l141 242h132l-212 -338l228 -362h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 614,
    d: "M367 276v-276h-120v276l-239 424h132l171 -313l171 313h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 597,
    d: "M48 700h535l-364 -586h344v-114h-549l366 586h-332v114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 330,
    d: "M184 660v-794h114v-96h-224v986h224v-96h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 520,
    d: "M418 -141l-400 898l96 43l400 -898z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 330,
    d: "M146 -134v794h-114v96h224v-986h-224v96h114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 537,
    d: "M10 350l206 406h105l206 -406h-125l-133 274l-135 -274h-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 500,
    d: "M42 -230v114h416v-114h-416z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 272,
    d: "M0 675l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 536,
    d: "M246 88q32 0 59.5 14t38.5 28l12 13v49q-43 24 -108 24q-34 0 -61 -16t-27 -51q0 -61 86 -61zM260 486q101 0 158.5 -47.5t57.5 -129.5v-309h-111v60q-6 -8 -17 -20t-51 -32t-88 -20q-70 0 -120.5 43t-50.5 116q0 68 54 112.5t132 44.5q39 0 72 -8.5t46 -17.5l14 -8v27 q0 42 -31.5 62t-70.5 20q-31 0 -66.5 -8.5t-55.5 -17.5l-20 -9l-39 99q88 43 187 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 587,
    d: "M74 0v756h120v-332q5 7 15 17.5t44.5 27.5t74.5 17q94 0 162.5 -71t68.5 -178t-68.5 -178t-162.5 -71q-29 0 -54 7.5t-40.5 18.5t-27 22t-16.5 18l-5 8v-62h-111zM194 308v-142q4 -7 11.5 -18t37 -29.5t64.5 -18.5q60 0 95 38.5t35 98.5t-35 98.5t-95 38.5q-22 0 -42 -7 t-32.5 -16.5t-21.5 -19t-13 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 497,
    d: "M283 100q23 0 43 6t33 14.5t23 17t14 14.5l4 6l79 -80q-3 -4 -8 -10t-24 -21.5t-40 -27.5t-54.5 -21.5t-69.5 -9.5q-107 0 -181 72.5t-74 176.5q0 105 74 177t181 72q56 0 104.5 -22t68.5 -44l21 -22l-83 -74q-4 6 -12.5 14t-37.5 22t-61 14q-59 0 -96 -40t-37 -97 t37 -97t96 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 587,
    d: "M513 756v-756h-111v62q-2 -3 -5 -8t-16 -18t-28 -22.5t-40 -17.5t-54 -8q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q40 0 73.5 -15.5t47.5 -30.5l13 -16v332h120zM393 166v142q-4 7 -11.5 18t-37 29.5t-64.5 18.5q-60 0 -95 -38.5t-35 -98.5t35 -98.5t95 -38.5 q22 0 42 7t32.5 16.5t21.5 19t13 16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 533,
    d: "M266 486q100 0 169.5 -70t69.5 -177q0 -27 -1 -45h-354q8 -36 44.5 -66t88.5 -30q37 0 69.5 12t46.5 24l14 12l60 -90q-8 -8 -24 -19t-65.5 -30t-100.5 -19q-108 0 -181.5 72t-73.5 177t68 177t170 72zM150 281h235q-2 36 -33.5 66t-85.5 30q-53 0 -82.5 -29.5 t-33.5 -66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 371,
    d: "M16 366v108h94v116q0 91 51.5 134.5t118.5 43.5q29 0 55.5 -6t38.5 -12l11 -7l-45 -101q-18 14 -48 14q-23 0 -42.5 -16.5t-19.5 -55.5v-110h116v-108h-116v-366h-120v366h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 573,
    d: "M393 49q-49 -61 -134 -61q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62h111v-478q0 -117 -73.5 -177.5t-181.5 -60.5q-60 0 -116.5 22.5t-82.5 45.5l-26 22l68 92q7 -8 20.5 -19.5t55 -31t81.5 -19.5q67 0 101 33t34 89v57z M393 166v142q-4 7 -11.5 18t-37 29.5t-64.5 18.5q-60 0 -95 -38.5t-35 -98.5t35 -98.5t95 -38.5q35 0 63 16.5t39 33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 562,
    d: "M328 486q72 0 123 -48.5t51 -130.5v-307h-120v277q0 49 -26 73t-68 24q-17 0 -33 -6.5t-27 -15.5t-19 -18t-11 -16l-4 -6v-312h-120v756h120v-339l5 7.5t15.5 16.5t26.5 21t37.5 16.5t49.5 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 278,
    d: "M79 0v474h120v-474h-120zM60 627q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 332,
    d: "M-35 -211l43 101q31 -20 57 -20q13 0 22.5 2.5t21.5 11.5t18.5 30.5t6.5 53.5v506h120v-517q0 -55 -17 -96t-44.5 -62t-56.5 -31t-58 -10t-57.5 8t-42.5 16zM114 627q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 535,
    d: "M194 756v-469l170 187h155l-208 -224l222 -250h-158l-181 207v-207h-120v756h120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 268,
    d: "M74 0v756h120v-756h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 836,
    d: "M610 486q74 0 120 -48.5t46 -132.5v-305h-120v274q0 100 -85 100q-18 0 -34 -6.5t-26 -15t-18 -17.5t-11 -15l-4 -7v-313h-120v274q0 100 -85 100q-18 0 -34 -6.5t-26 -15t-18 -17.5t-11 -15l-4 -7v-313h-120v474h112v-69q2 3 5.5 8.5t16 19.5t27.5 24.5t39.5 19.5 t51.5 9q32 0 59 -8.5t42.5 -21t26.5 -24.5t15 -20l4 -9q2 3 5 9t16 20t29 25t43 20t58 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 548,
    d: "M314 486q72 0 123 -48.5t51 -130.5v-307h-120v277q0 49 -26 73t-68 24q-17 0 -33 -6.5t-27 -15t-19 -17.5t-11 -15l-4 -7v-313h-120v474h112v-69q2 3 5.5 8.5t16 19.5t27.5 24.5t40 19.5t53 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 562,
    d: "M281 486q106 0 179.5 -72t73.5 -177q0 -104 -73.5 -176.5t-179.5 -72.5t-179.5 72.5t-73.5 176.5q0 105 73.5 177t179.5 72zM281 100q59 0 95 40t36 97t-36 97t-95 40t-95 -40t-36 -97t36 -97t95 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 573,
    d: "M60 474h111v-62q2 3 5.5 8t16.5 18t28 22.5t40.5 17.5t52.5 8q94 0 162.5 -71t68.5 -178t-68.5 -178t-162.5 -71q-85 0 -134 61v-279h-120v704zM180 308v-142q4 -7 11.5 -18t37 -29.5t64.5 -18.5q60 0 95 38.5t35 98.5t-35 98.5t-95 38.5q-22 0 -42 -7t-32.5 -16.5 t-21.5 -19t-13 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 573,
    d: "M402 474h111v-704h-120v279q-49 -61 -134 -61q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62zM393 166v142q-4 7 -11.5 18t-37 29.5t-64.5 18.5q-60 0 -95 -38.5t-35 -98.5t35 -98.5t95 -38.5q22 0 42 7t32.5 16.5t21.5 19t13 16.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 387,
    d: "M303 486q19 0 39.5 -4t31.5 -8l11 -3l-42 -108q-22 11 -57 11q-32 0 -58.5 -16t-37.5 -32l-10 -16v-310h-120v474h114v-69q2 3 5 8.5t15 19.5t25.5 24.5t36 19.5t47.5 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 483,
    d: "M30 74l67 87q7 -8 19.5 -19t50 -30t73.5 -19q39 0 64.5 11t25.5 32q0 22 -18 31t-76 21q-176 37 -176 150q0 59 55.5 103.5t148.5 44.5q48 0 92.5 -14.5t65.5 -29.5l20 -14l-60 -88q-54 41 -118 41q-36 0 -61 -12t-25 -33q0 -20 22 -29.5t90 -23.5q80 -17 120.5 -49 t40.5 -100q0 -62 -58.5 -104t-148.5 -42q-39 0 -75.5 9t-60.5 21.5t-42.5 25t-27.5 21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 416,
    d: "M22 366v108h93v141h120v-141h143v-108h-143v-191q0 -75 62 -75q12 0 24.5 4t18.5 8l7 5l44 -98q-45 -31 -114 -31q-70 0 -116 46.5t-46 121.5v210h-93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 548,
    d: "M234 -12q-72 0 -123 48.5t-51 130.5v307h120v-274q0 -100 94 -100q28 0 51.5 14.5t32.5 29.5l10 14v316h120v-474h-112v69q-2 -3 -5.5 -8.5t-16.5 -19.5t-28 -24.5t-40 -19.5t-52 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 506,
    d: "M2 474h133l120 -258l120 258h129l-251 -498z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 768,
    d: "M4 474h134l98 -243l103 243h101l100 -243l102 243h122l-229 -498l-152 338l-150 -338z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 525,
    d: "M192 245l-163 229h141l97 -146l95 146h137l-165 -229l175 -245h-143l-107 162l-107 -162h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 557,
    d: "M20 -192l56 93q32 -31 63 -31t47.5 13.5t33.5 56.5l19 49l-231 485h133l160 -347l125 347h129l-230 -580q-54 -136 -178 -136q-32 0 -64 12.5t-47 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 495,
    d: "M47 474h422l-235 -362h224v-112h-428l235 362h-218v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 350,
    d: "M314 756v-108q-35 0 -51.5 -14t-16.5 -60v-186q0 -72 -27 -99t-72 -29v-4q45 -2 72 -29t27 -99v-176q0 -46 16.5 -60t51.5 -14v-108h-54q-59 0 -96.5 37.5t-37.5 97.5v208q0 61 -27 81t-73 20v88q46 0 73 20t27 81v218q0 60 37.5 97.5t96.5 37.5h54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 260,
    d: "M72 -230v970h116v-970h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 350,
    d: "M36 648v108h54q59 0 96.5 -37.5t37.5 -97.5v-218q0 -61 27 -81t73 -20v-88q-46 0 -73 -20t-27 -81v-208q0 -60 -37.5 -97.5t-96.5 -37.5h-54v108q35 0 51.5 14t16.5 60v176q0 72 27 99t72 29v4q-45 2 -72 29t-27 99v186q0 46 -16.5 60t-51.5 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 489,
    d: "M106 258l-86 53l5 12.5t16 27t28.5 34.5t42.5 27t58 12q32 0 80.5 -23.5t66.5 -23.5q24 0 40.5 14t20.5 28l5 14l86 -54l-5 -12.5t-15.5 -26.5t-28 -34t-42.5 -27t-58 -12q-34 0 -83 23.5t-64 23.5q-24 0 -40.5 -14t-21.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nbspace",
    unicode: "\xA0",
    horizAdvX: 294
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 306,
    d: "M210 274l5 -500h-124l5 500h114zM74 407q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    d: "M287 -94v85q-94 13 -155.5 82t-61.5 164t61.5 164t155.5 82v87h63v-85q49 -5 91 -26.5t60 -40.5l18 -20l-83 -74q-31 38 -86 48v-270q28 4 51 18t32 26l9 12l79 -80q-2 -3 -7 -8.5t-21.5 -19.5t-34.5 -25.5t-47.5 -22t-60.5 -13.5v-83h-63zM192 237q0 -47 25.5 -83.5 t69.5 -48.5v264q-44 -13 -69.5 -49.5t-25.5 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    d: "M194 500q0 -37 61 -133h185v-84h-143q10 -29 10 -59q0 -19 -4.5 -38t-8.5 -29l-5 -10q17 -6 54.5 -26.5t58.5 -20.5q26 0 43.5 15.5t22.5 30.5l4 16l93 -52q-2 -5 -5.5 -13t-17 -29t-30.5 -37.5t-47 -29.5t-64 -13q-51 0 -100.5 28t-78.5 28q-27 0 -48 -16t-29 -32 l-8 -16l-92 64q5 10 14.5 25.5t40 45t62.5 37.5q9 10 17 32t8 43q0 20 -18 56h-124v84h78q-49 88 -49 141q0 79 59 141.5t173 62.5q40 0 76 -11.5t59 -28t40 -33t25 -27.5l7 -12l-87 -70q-1 3 -4 7.5t-14 16.5t-23.5 21.5t-33.5 17t-45 7.5q-51 0 -81.5 -28.5t-30.5 -71.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    d: "M58 323q0 69 37 126l-71 71l70 70l70 -71q59 38 127 38t125 -38l71 71l70 -70l-71 -71q38 -57 38 -126q0 -68 -38 -127l71 -70l-70 -70l-71 71q-57 -37 -125 -37q-71 0 -126 37l-71 -71l-70 70l71 71q-37 55 -37 126zM170 322q0 -50 35.5 -85.5t85.5 -35.5q51 0 86 35 t35 86q0 48 -36 85t-85 37q-50 0 -85.5 -36t-35.5 -86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    d: "M25 385v84h96l-130 231h132l171 -313l171 313h124l-130 -231h96v-84h-144l-39 -70h183v-84h-205v-231h-120v231h-205v84h183l-40 70h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 260,
    d: "M72 350v390h116v-390h-116zM72 -230v390h116v-390h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 508,
    d: "M448 264q0 -56 -32 -95t-72 -57q83 -58 83 -151q0 -64 -52.5 -109.5t-134.5 -45.5q-30 0 -59 8.5t-48.5 20t-35 23.5t-22.5 20l-7 9l76 79q4 -6 11.5 -14t32.5 -22t52 -14q29 0 48 17.5t19 41.5q0 26 -21 43.5t-84 53.5q-39 22 -57.5 34.5t-45 35.5t-38 50.5t-11.5 61.5 q0 55 32.5 94.5t71.5 56.5q-83 58 -83 142q0 68 52.5 116.5t134.5 48.5q49 0 91.5 -20.5t60.5 -41.5l19 -20l-79 -74q-4 5 -11 12.5t-30.5 20.5t-50.5 13q-29 0 -48 -17.5t-19 -41.5q0 -26 21 -43.5t84 -53.5q39 -22 57.5 -34.5t45 -35.5t38 -50.5t11.5 -61.5zM249 172l5 -3 q28 4 51 25.5t23 53.5t-14 51t-65 47l-5 2q-28 -3 -51 -24.5t-23 -53.5t14 -51t65 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 392,
    d: "M14 621q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM220 621q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 819,
    d: "M48 350q0 150 106 256t256 106t255.5 -106t105.5 -256t-105.5 -256t-255.5 -106t-256 106t-106 256zM134 350q0 -113 81.5 -194.5t194.5 -81.5t194 81.5t81 194.5t-81 194.5t-194 81.5t-194.5 -81.5t-81.5 -194.5zM418 241q28 0 51.5 11.5t32.5 23.5l9 11l62 -63 q-6 -8 -18 -20t-52 -31.5t-85 -19.5q-84 0 -143 57.5t-59 139.5t59 139.5t143 57.5q45 0 83.5 -17.5t54.5 -35.5l16 -17l-66 -59q-3 4 -10 11t-30 18t-48 11q-47 0 -76 -31.5t-29 -76.5q0 -46 29 -77.5t76 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 325,
    d: "M147 464q20 0 37.5 9t25.5 18l7 9v22q-29 16 -69 16q-52 0 -52 -37q0 -19 15.5 -28t35.5 -9zM159 712q63 0 98 -31t35 -80v-195h-70v39q-3 -5 -10 -12.5t-32.5 -20.5t-55.5 -13q-41 0 -73.5 27t-32.5 72q0 44 32.5 71.5t81.5 27.5q24 0 45.5 -6.5t30.5 -12.5l9 -7v19 q0 24 -20 36.5t-46 12.5q-19 0 -40.5 -5.5t-33.5 -10.5l-12 -5l-25 66q49 28 119 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 529,
    d: "M6 245l183 236l82 -63l-138 -173l138 -173l-82 -63zM221 245l183 236l82 -63l-138 -173l138 -173l-82 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 674,
    d: "M18 394v114h600v-316h-118v202h-482z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "softhyphen",
    unicode: "\xAD",
    horizAdvX: 333,
    d: "M33 190v114h267v-114h-267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 425,
    d: "M137 417v190h98q28 0 45.5 -18t17.5 -44q0 -45 -43 -58l50 -70h-60l-40 61h-14v-61h-54zM211 524q35 0 35 21t-35 21h-20v-42h20zM5 510q0 87 61 148.5t147 61.5q87 0 148.5 -61.5t61.5 -148.5q0 -86 -61.5 -147t-148.5 -61q-86 0 -147 61t-61 147zM70 510q0 -59 42 -101 t101 -42t101.5 42t42.5 101t-42.5 101.5t-101.5 42.5t-101 -42.5t-42 -101.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 334,
    d: "M6 572v108h322v-108h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 357,
    d: "M22 555q0 65 45.5 111t110.5 46t111 -46t46 -111t-46 -110.5t-111 -45.5t-110.5 45.5t-45.5 110.5zM108 555q0 -30 21 -50.5t50 -20.5t50 20.5t21 50.5t-21 50.5t-50 20.5t-50 -20.5t-21 -50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 520,
    d: "M38 0v102h444v-102h-444zM38 269v102h167v130h110v-130h167v-102h-167v-123h-110v123h-167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 362,
    d: "M32 394l152 184q1 2 13 16.5t17 22t11 21.5t6 26q0 25 -17.5 41t-45.5 16q-24 0 -40.5 -14.5t-21.5 -29.5l-5 -15l-79 27q1 5 4 13t14.5 28t26 35.5t42 28t59.5 12.5q74 0 114 -42t40 -98q0 -48 -32 -90l-75 -100h111v-82h-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 368,
    d: "M235 680q0 20 -15.5 32.5t-43.5 12.5q-14 0 -26.5 -4.5t-20 -10.5t-12.5 -12.5t-7 -11.5l-3 -4l-70 38q2 3 5 9t15 21t26.5 26t39.5 20.5t53 9.5q64 0 106.5 -33t42.5 -93q0 -24 -11.5 -42.5t-23.5 -25.5l-12 -6q2 -1 5.5 -2.5t13 -9t16.5 -16.5t13 -26t6 -37 q0 -60 -45 -93.5t-109 -33.5q-32 0 -59 10t-43 24t-27 28t-15 24l-4 10l74 41q2 -6 6 -15.5t23 -25t45 -15.5q31 0 47.5 13.5t16.5 32.5q0 49 -67 49h-22v70h15q27 0 47 11t20 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 272,
    d: "M191 753l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 548,
    d: "M234 -12q-27 0 -54 8v-226h-120v704h120v-274q0 -100 94 -100q28 0 51.5 14.5t32.5 29.5l10 14v316h120v-474h-112v69q-2 -3 -5.5 -8.5t-16.5 -19.5t-28 -24.5t-40 -19.5t-52 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\u03BC",
    horizAdvX: 548,
    d: "M234 -12q-27 0 -54 8v-226h-120v704h120v-274q0 -100 94 -100q28 0 51.5 14.5t32.5 29.5l10 14v316h120v-474h-112v69q-2 -3 -5.5 -8.5t-16.5 -19.5t-28 -24.5t-40 -19.5t-52 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 672,
    d: "M386 598v-786h-112v414q-98 0 -168 69t-70 167t70 168t168 70h324v-888h-112v786h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 262,
    d: "M52 350q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 315,
    d: "M241 -57l-68 -214l-111 32l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 323,
    d: "M8 669l158 131h85v-406h-93v289l-97 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 357,
    d: "M22 555q0 65 46 111t111 46t111 -46t46 -111t-46 -111t-111 -46t-111 46t-46 111zM108 555q0 -29 21 -50t50 -21t50 21t21 50t-21 50t-50 21t-50 -21t-21 -50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 529,
    d: "M340 481l183 -236l-183 -236l-82 63l138 173l-138 173zM125 481l183 -236l-183 -236l-82 63l138 173l-138 173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 830,
    d: "M180 7l471 724l57 -39l-471 -724zM449 78l208 328h98v-250h50v-78h-50v-78h-86v78h-220zM585 156h84v134zM26 569l158 131h85v-406h-93v289l-97 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 830,
    d: "M479 0l152 184q1 2 13 16.5t17 22t11 21.5t6 26q0 25 -17.5 41t-45.5 16q-24 0 -40.5 -14.5t-21.5 -29.5l-5 -15l-79 27q1 5 4 13t14.5 28t26 35.5t42 28t59.5 12.5q74 0 114 -42t40 -98q0 -48 -32 -90l-75 -100h111v-82h-294zM131 7l471 724l57 -39l-471 -724zM16 569 l158 131h85v-406h-93v289l-97 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 830,
    d: "M190 7l471 724l57 -39l-471 -724zM245 580q0 20 -15.5 32.5t-43.5 12.5q-14 0 -26.5 -4.5t-20 -10.5t-12.5 -12.5t-7 -11.5l-3 -4l-70 38q2 3 5 9t15 21t26.5 26t39.5 20.5t53 9.5q64 0 106.5 -33t42.5 -93q0 -24 -11.5 -42.5t-23.5 -25.5l-12 -6q2 -1 5.5 -2.5t13 -9 t16.5 -16.5t13 -26t6 -37q0 -60 -45 -93.5t-109 -33.5q-32 0 -59 10t-43 24t-27 28t-15 24l-4 10l74 41q2 -6 6 -15.5t23 -25t45 -15.5q31 0 47.5 13.5t16.5 32.5q0 49 -67 49h-22v70h15q27 0 47 11t20 35zM449 78l208 328h98v-250h50v-78h-50v-78h-86v78h-220zM585 156h84 v134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 489,
    d: "M160 -38q0 -35 27.5 -60.5t65.5 -25.5t67.5 24t39.5 48l11 24l102 -47q-2 -7 -6 -18t-22 -39t-40.5 -49.5t-63 -39t-88.5 -17.5q-90 0 -151.5 58t-61.5 142q0 42 16 76.5t35.5 55t59.5 55.5q27 24 32 33t5 36v51h119v-74q0 -11 -0.5 -19.5t-3.5 -17.5t-4.5 -14.5 t-8 -13.5t-9 -12t-12.5 -13t-14 -12.5t-18 -15.5t-20 -17q-32 -28 -44.5 -47t-12.5 -51zM326 407q0 -33 -23 -56t-56 -23t-56 23t-23 56t23 56t56 23t56 -23t23 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 678,
    d: "M6 0l272 700h122l272 -700h-121l-64 166h-296l-64 -166h-121zM339 549l-105 -273h210zM191 913l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 678,
    d: "M6 0l272 700h122l272 -700h-121l-64 166h-296l-64 -166h-121zM339 549l-105 -273h210zM409 991l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 678,
    d: "M6 0l272 700h122l272 -700h-121l-64 166h-296l-64 -166h-121zM339 549l-105 -273h210zM153 824l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 678,
    d: "M6 0l272 700h122l272 -700h-121l-64 166h-296l-64 -166h-121zM339 549l-105 -273h210zM220 775l-84 61q1 4 4 11t14.5 25t25.5 32t38 25t52 11q32 0 76.5 -29t60.5 -29q19 0 32.5 16t17.5 32l4 17l82 -65q-1 -4 -4 -11.5t-14 -25.5t-24.5 -32t-37 -25.5t-50.5 -11.5 q-31 0 -76 28.5t-61 28.5q-19 0 -33 -14.5t-19 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 678,
    d: "M6 0l272 700h122l272 -700h-121l-64 166h-296l-64 -166h-121zM339 549l-105 -273h210zM157 859q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM363 859q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 678,
    d: "M6 0l272 700h122l272 -700h-121l-64 166h-296l-64 -166h-121zM339 549l-105 -273h210zM217 863q0 49 36 84.5t86 35.5t86 -35.5t36 -84.5t-36 -84.5t-86 -35.5t-86 35.5t-36 84.5zM285 863q0 -23 15.5 -38.5t38.5 -15.5t38.5 15.5t15.5 38.5t-15.5 38.5t-38.5 15.5 t-38.5 -15.5t-15.5 -38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 915,
    d: "M493 605l-206 -348h206v348zM613 588v-172h230v-114h-230v-190h260v-112h-380v143h-272l-85 -143h-130l413 700h448v-112h-254z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 676,
    d: "M409 -62l-68 -214l-111 32l72 194zM389 100q34 0 66.5 9t53.5 21.5t37.5 25t23.5 21.5l8 9l80 -79q-4 -5 -11 -13t-32.5 -28.5t-54.5 -36t-75 -28.5t-96 -13q-152 0 -253.5 103.5t-101.5 258.5t101.5 258.5t253.5 103.5q47 0 91 -11.5t73 -27.5t51.5 -32t33.5 -27l10 -12 l-81 -79q-3 3 -7.5 8.5t-22 18.5t-36.5 23t-49.5 18.5t-62.5 8.5q-101 0 -167 -73t-66 -177t66 -177t167 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 546,
    d: "M194 586v-170h280v-114h-280v-188h310v-114h-430v700h424v-114h-304zM147 913l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 546,
    d: "M194 586v-170h280v-114h-280v-188h310v-114h-430v700h424v-114h-304zM361 991l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 546,
    d: "M194 586v-170h280v-114h-280v-188h310v-114h-430v700h424v-114h-304zM99 824l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 546,
    d: "M194 586v-170h280v-114h-280v-188h310v-114h-430v700h424v-114h-304zM109 859q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM315 859q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 296,
    d: "M88 0v700h120v-700h-120zM4 913l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 296,
    d: "M85 0v700h120v-700h-120zM211 991l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 296,
    d: "M88 0v700h120v-700h-120zM-36 834l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 296,
    d: "M74 0v700h120v-700h-120zM-48 859q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM158 859q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 708,
    d: "M328 700q152 0 249 -99t97 -251t-97 -251t-249 -99h-226v305h-90v104h90v291h226zM330 114q99 0 160.5 69t61.5 167q0 99 -61.5 167.5t-160.5 68.5h-108v-177h202v-104h-202v-191h108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 726,
    d: "M74 700h108l350 -482v482h120v-700h-108l-350 481v-481h-120v700zM247 775l-84 61q1 4 4 11t14.5 25t25.5 32t38 25t52 11q32 0 76.5 -29t60.5 -29q19 0 32.5 16t17.5 32l4 17l82 -65q-1 -4 -4 -11.5t-14 -25.5t-24.5 -32t-37 -25.5t-50.5 -11.5q-32 0 -76 28.5t-61 28.5 q-19 0 -33 -14.5t-18 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 776,
    d: "M388 712q153 0 253.5 -103t100.5 -259t-100.5 -259t-253.5 -103t-253.5 103t-100.5 259t100.5 259t253.5 103zM388 102q103 0 167.5 72t64.5 176t-64.5 176t-167.5 72t-167.5 -72t-64.5 -176t64.5 -176t167.5 -72zM249 913l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 776,
    d: "M441 991l81 -79l-175 -168l-77 73zM388 712q153 0 253.5 -103t100.5 -259t-100.5 -259t-253.5 -103t-253.5 103t-100.5 259t100.5 259t253.5 103zM388 102q103 0 167.5 72t64.5 176t-64.5 176t-167.5 72t-167.5 -72t-64.5 -176t64.5 -176t167.5 -72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 776,
    d: "M388 712q153 0 253.5 -103t100.5 -259t-100.5 -259t-253.5 -103t-253.5 103t-100.5 259t100.5 259t253.5 103zM388 102q103 0 167.5 72t64.5 176t-64.5 176t-167.5 72t-167.5 -72t-64.5 -176t64.5 -176t167.5 -72zM204 824l186 134l186 -134l-66 -82l-120 91l-122 -91z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 776,
    d: "M388 712q153 0 253.5 -103t100.5 -259t-100.5 -259t-253.5 -103t-253.5 103t-100.5 259t100.5 259t253.5 103zM388 102q103 0 167.5 72t64.5 176t-64.5 176t-167.5 72t-167.5 -72t-64.5 -176t64.5 -176t167.5 -72zM270 775l-84 61q1 4 4 11t14.5 25t25.5 32t38 25t52 11 q32 0 76.5 -29t60.5 -29q19 0 32.5 16t17.5 32l4 17l82 -65q-1 -4 -4 -11.5t-14 -25.5t-24.5 -32t-37 -25.5t-50.5 -11.5q-31 0 -76 28.5t-61 28.5q-19 0 -33 -14.5t-19 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 776,
    d: "M388 712q153 0 253.5 -103t100.5 -259t-100.5 -259t-253.5 -103t-253.5 103t-100.5 259t100.5 259t253.5 103zM388 102q103 0 167.5 72t64.5 176t-64.5 176t-167.5 72t-167.5 -72t-64.5 -176t64.5 -176t167.5 -72zM206 859q0 33 23 56t56 23t56 -23t23 -56t-23 -56 t-56 -23t-56 23t-23 56zM412 859q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 520,
    d: "M107 24l-78 78l153 153l-153 153l78 78l153 -153l153 153l78 -78l-153 -153l153 -153l-78 -78l-153 153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 784,
    d: "M65 12l70 83q-97 102 -97 255q0 156 100.5 259t253.5 103q118 0 208 -65l70 82l49 -41l-70 -83q97 -103 97 -255q0 -156 -100.5 -259t-253.5 -103q-117 0 -209 65l-69 -82zM160 350q0 -94 53 -163l312 370q-57 41 -133 41q-103 0 -167.5 -72t-64.5 -176zM392 102 q103 0 167.5 72t64.5 176q0 93 -53 162l-312 -369q57 -41 133 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 688,
    d: "M495 269v431h120v-446q0 -117 -74 -191.5t-196 -74.5t-196 74.5t-74 191.5v446h120v-431q0 -77 38.5 -122t111.5 -45t111.5 45t38.5 122zM189 913l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 688,
    d: "M494 269v431h120v-446q0 -117 -74 -191.5t-196 -74.5t-196 74.5t-74 191.5v446h120v-431q0 -77 38.5 -122t111.5 -45t111.5 45t38.5 122zM423 991l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 688,
    d: "M494 269v431h120v-446q0 -117 -74 -191.5t-196 -74.5t-196 74.5t-74 191.5v446h120v-431q0 -77 38.5 -122t111.5 -45t111.5 45t38.5 122zM158 824l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 688,
    d: "M494 269v431h120v-446q0 -117 -74 -191.5t-196 -74.5t-196 74.5t-74 191.5v446h120v-431q0 -77 38.5 -122t111.5 -45t111.5 45t38.5 122zM162 859q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM368 859q0 33 23 56t56 23t56 -23t23 -56t-23 -56 t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 614,
    d: "M367 276v-276h-120v276l-239 424h132l171 -313l171 313h124zM386 991l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 545,
    d: "M74 0v700h120v-111h86q108 0 177.5 -54.5t69.5 -159.5t-69.5 -159.5t-177.5 -54.5h-86v-161h-120zM265 273q67 0 104.5 22.5t37.5 79.5t-37.5 79.5t-104.5 22.5h-71v-204h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 601,
    d: "M64 0v543q0 102 64.5 163.5t169.5 61.5q89 0 153.5 -55.5t64.5 -156.5q0 -29 -8.5 -54.5t-21 -40.5t-24.5 -26t-20 -15l-9 -4q5 -1 14 -3.5t32 -15t40 -31t31.5 -55.5t14.5 -85q0 -124 -76.5 -181t-205.5 -57h-20v112h15q86 0 125.5 34.5t39.5 91.5q0 126 -172 126v106 q40 0 66.5 11t37.5 28.5t15 31t4 28.5q0 35 -25.5 66t-72.5 31q-52 0 -82 -30t-30 -81v-543h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 536,
    d: "M246 88q32 0 59.5 14t38.5 28l12 13v49q-43 24 -108 24q-34 0 -61 -16t-27 -51q0 -61 86 -61zM260 486q101 0 158.5 -47.5t57.5 -129.5v-309h-111v60q-6 -8 -17 -20t-51 -32t-88 -20q-70 0 -120.5 43t-50.5 116q0 68 54 112.5t132 44.5q39 0 72 -8.5t46 -17.5l14 -8v27 q0 42 -31.5 62t-70.5 20q-31 0 -66.5 -8.5t-55.5 -17.5l-20 -9l-39 99q88 43 187 43zM133 704l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 536,
    d: "M344 783l81 -79l-175 -168l-77 73zM246 88q32 0 59.5 14t38.5 28l12 13v49q-43 24 -108 24q-34 0 -61 -16t-27 -51q0 -61 86 -61zM260 486q101 0 158.5 -47.5t57.5 -129.5v-309h-111v60q-6 -8 -17 -20t-51 -32t-88 -20q-70 0 -120.5 43t-50.5 116q0 68 54 112.5t132 44.5 q39 0 72 -8.5t46 -17.5l14 -8v27q0 42 -31.5 62t-70.5 20q-31 0 -66.5 -8.5t-55.5 -17.5l-20 -9l-39 99q88 43 187 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 536,
    d: "M246 88q32 0 59.5 14t38.5 28l12 13v49q-43 24 -108 24q-34 0 -61 -16t-27 -51q0 -61 86 -61zM260 486q101 0 158.5 -47.5t57.5 -129.5v-309h-111v60q-6 -8 -17 -20t-51 -32t-88 -20q-70 0 -120.5 43t-50.5 116q0 68 54 112.5t132 44.5q39 0 72 -8.5t46 -17.5l14 -8v27 q0 42 -31.5 62t-70.5 20q-31 0 -66.5 -8.5t-55.5 -17.5l-20 -9l-39 99q88 43 187 43zM99 606l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 536,
    d: "M246 88q32 0 59.5 14t38.5 28l12 13v49q-43 24 -108 24q-34 0 -61 -16t-27 -51q0 -61 86 -61zM260 486q101 0 158.5 -47.5t57.5 -129.5v-309h-111v60q-6 -8 -17 -20t-51 -32t-88 -20q-70 0 -120.5 43t-50.5 116q0 68 54 112.5t132 44.5q39 0 72 -8.5t46 -17.5l14 -8v27 q0 42 -31.5 62t-70.5 20q-31 0 -66.5 -8.5t-55.5 -17.5l-20 -9l-39 99q88 43 187 43zM150 554l-84 61q1 4 4 11t14.5 25t25.5 32t38 25t52 11q32 0 76.5 -29t60.5 -29q19 0 32.5 16.5t17.5 32.5l4 16l82 -65q-1 -4 -4 -11.5t-14 -25.5t-24.5 -32t-37 -25.5t-50.5 -11.5 q-31 0 -76 28.5t-61 28.5q-19 0 -33 -14.5t-19 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 536,
    d: "M246 88q32 0 59.5 14t38.5 28l12 13v49q-43 24 -108 24q-34 0 -61 -16t-27 -51q0 -61 86 -61zM260 486q101 0 158.5 -47.5t57.5 -129.5v-309h-111v60q-6 -8 -17 -20t-51 -32t-88 -20q-70 0 -120.5 43t-50.5 116q0 68 54 112.5t132 44.5q39 0 72 -8.5t46 -17.5l14 -8v27 q0 42 -31.5 62t-70.5 20q-31 0 -66.5 -8.5t-55.5 -17.5l-20 -9l-39 99q88 43 187 43zM95 631q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM301 631q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 536,
    d: "M246 88q32 0 59.5 14t38.5 28l12 13v49q-43 24 -108 24q-34 0 -61 -16t-27 -51q0 -61 86 -61zM260 486q101 0 158.5 -47.5t57.5 -129.5v-309h-111v60q-6 -8 -17 -20t-51 -32t-88 -20q-70 0 -120.5 43t-50.5 116q0 68 54 112.5t132 44.5q39 0 72 -8.5t46 -17.5l14 -8v27 q0 42 -31.5 62t-70.5 20q-31 0 -66.5 -8.5t-55.5 -17.5l-20 -9l-39 99q88 43 187 43zM146 647q0 49 36 84.5t86 35.5t86 -35.5t36 -84.5t-36 -84.5t-86 -35.5t-86 35.5t-36 84.5zM214 647q0 -23 16 -38.5t38 -15.5t38 15.5t16 38.5t-16 38.5t-38 15.5t-38 -15.5t-16 -38.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 865,
    d: "M602 486q103 0 169 -69t66 -178q0 -26 -1 -44h-351q8 -36 44 -66.5t88 -30.5q37 0 69.5 12t46.5 24l14 12l60 -90q-8 -8 -24 -19t-65.5 -30t-100.5 -19q-124 0 -201 92q-69 -92 -193 -92q-80 0 -132.5 43t-52.5 107t43 103t134 39h149q0 43 -39 69.5t-84 26.5 q-32 0 -64.5 -10.5t-48.5 -21.5l-17 -10l-53 94q9 6 25 16t65.5 26t97.5 16q67 0 112 -25t67 -55q70 80 177 80zM485 280h233q-2 36 -32 66.5t-84 30.5q-53 0 -83 -30t-34 -67zM239 94q62 0 96 29t34 71h-137q-74 0 -74 -50t81 -50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 497,
    d: "M319 -62l-68 -214l-111 32l72 194zM283 100q23 0 43 6t33 14.5t23 17t14 14.5l4 6l79 -80q-3 -4 -8 -10t-24 -21.5t-40 -27.5t-54.5 -21.5t-69.5 -9.5q-107 0 -181 72.5t-74 176.5q0 105 74 177t181 72q56 0 104.5 -22t68.5 -44l21 -22l-83 -74q-4 6 -12.5 14t-37.5 22 t-61 14q-59 0 -96 -40t-37 -97t37 -97t96 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 533,
    d: "M266 486q100 0 169.5 -70t69.5 -177q0 -27 -1 -45h-354q8 -36 44.5 -66t88.5 -30q37 0 69.5 12t46.5 24l14 12l60 -90q-8 -8 -24 -19t-65.5 -30t-100.5 -19q-108 0 -181.5 72t-73.5 177t68 177t170 72zM150 281h235q-2 36 -33.5 66t-85.5 30q-53 0 -82.5 -29.5 t-33.5 -66.5zM132 694l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 533,
    d: "M266 486q100 0 169.5 -70t69.5 -177q0 -27 -1 -45h-354q8 -36 44.5 -66t88.5 -30q37 0 69.5 12t46.5 24l14 12l60 -90q-8 -8 -24 -19t-65.5 -30t-100.5 -19q-108 0 -181.5 72t-73.5 177t68 177t170 72zM150 281h235q-2 36 -33.5 66t-85.5 30q-53 0 -82.5 -29.5 t-33.5 -66.5zM335 773l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 533,
    d: "M85 618l186 134l186 -134l-66 -82l-120 91l-122 -91zM266 486q100 0 169.5 -70t69.5 -177q0 -27 -1 -45h-354q8 -36 44.5 -66t88.5 -30q37 0 69.5 12t46.5 24l14 12l60 -90q-8 -8 -24 -19t-65.5 -30t-100.5 -19q-108 0 -181.5 72t-73.5 177t68 177t170 72zM150 281h235 q-2 36 -33.5 66t-85.5 30q-53 0 -82.5 -29.5t-33.5 -66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 533,
    d: "M84 631q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM290 631q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM266 486q100 0 169.5 -70t69.5 -177q0 -27 -1 -45h-354q8 -36 44.5 -66t88.5 -30q37 0 69.5 12t46.5 24l14 12l60 -90 q-8 -8 -24 -19t-65.5 -30t-100.5 -19q-108 0 -181.5 72t-73.5 177t68 177t170 72zM150 281h235q-2 36 -33.5 66t-85.5 30q-53 0 -82.5 -29.5t-33.5 -66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 278,
    d: "M0 695l81 79l171 -174l-77 -73zM77 0v462h120v-462h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 278,
    d: "M197 773l81 -79l-175 -168l-77 73zM73 0v462h120v-462h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 308,
    d: "M94 0v462h120v-462h-120zM-32 618l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 278,
    d: "M79 0v462h120v-462h-120zM-43 631q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM163 631q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 577,
    d: "M117 512l-36 78l101 47q-21 13 -59.5 32.5t-40.5 20.5l47 89q96 -47 160 -92l127 59l36 -78l-88 -41q165 -152 165 -355q0 -126 -71.5 -205t-178.5 -79q-105 0 -178 72t-73 177t73 177t178 72q48 0 86 -19q-36 55 -102 112zM279 100q58 0 94.5 40t36.5 97t-36.5 97 t-94.5 40t-94.5 -40t-36.5 -97t36.5 -97t94.5 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 548,
    d: "M314 486q72 0 123 -48.5t51 -130.5v-307h-120v277q0 49 -26 73t-68 24q-17 0 -33 -6.5t-27 -15t-19 -17.5t-11 -15l-4 -7v-313h-120v474h112v-69q2 3 5.5 8.5t16 19.5t27.5 24.5t40 19.5t53 9zM160 554l-84 61q1 4 4 11t14.5 25t25.5 32t38 25t52 11q32 0 76.5 -29 t60.5 -29q19 0 32.5 16.5t17.5 32.5l4 16l82 -65q-1 -4 -4 -11.5t-14 -25.5t-24.5 -32t-37 -25.5t-50.5 -11.5q-31 0 -76 28.5t-61 28.5q-19 0 -33 -14.5t-19 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 562,
    d: "M281 486q106 0 179.5 -72t73.5 -177q0 -104 -73.5 -176.5t-179.5 -72.5t-179.5 72.5t-73.5 176.5q0 105 73.5 177t179.5 72zM281 100q59 0 95 40t36 97t-36 97t-95 40t-95 -40t-36 -97t36 -97t95 -40zM125 695l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 562,
    d: "M356 773l81 -79l-175 -168l-77 73zM281 486q106 0 179.5 -72t73.5 -177q0 -104 -73.5 -176.5t-179.5 -72.5t-179.5 72.5t-73.5 176.5q0 105 73.5 177t179.5 72zM281 100q59 0 95 40t36 97t-36 97t-95 40t-95 -40t-36 -97t36 -97t95 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 562,
    d: "M281 486q106 0 179.5 -72t73.5 -177q0 -104 -73.5 -176.5t-179.5 -72.5t-179.5 72.5t-73.5 176.5q0 105 73.5 177t179.5 72zM281 100q59 0 95 40t36 97t-36 97t-95 40t-95 -40t-36 -97t36 -97t95 -40zM95 606l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 562,
    d: "M281 486q106 0 179.5 -72t73.5 -177q0 -104 -73.5 -176.5t-179.5 -72.5t-179.5 72.5t-73.5 176.5q0 105 73.5 177t179.5 72zM281 100q59 0 95 40t36 97t-36 97t-95 40t-95 -40t-36 -97t36 -97t95 -40zM164 550l-84 61q1 4 4 11t14.5 25t25.5 32t38 25t52 11 q32 0 76.5 -29t60.5 -29q19 0 32.5 16.5t17.5 32.5l4 16l82 -65q-1 -4 -4 -11.5t-14 -25.5t-24.5 -32t-37 -25.5t-50.5 -11.5q-31 0 -76 28.5t-61 28.5q-19 0 -33 -14.5t-19 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 562,
    d: "M281 486q106 0 179.5 -72t73.5 -177q0 -104 -73.5 -176.5t-179.5 -72.5t-179.5 72.5t-73.5 176.5q0 105 73.5 177t179.5 72zM281 100q59 0 95 40t36 97t-36 97t-95 40t-95 -40t-36 -97t36 -97t95 -40zM99 631q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23 t-23 56zM305 631q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 520,
    d: "M180 67q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM180 407q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM35 182v110h450v-110h-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 570,
    d: "M285 486q74 0 136 -38l43 51l48 -40l-43 -51q69 -71 69 -171q0 -104 -73.5 -176.5t-179.5 -72.5q-77 0 -138 39l-46 -54l-48 40l46 54q-67 70 -67 170q0 105 73.5 177t179.5 72zM285 100q59 0 95 40t36 97q0 46 -23 81l-172 -203q27 -15 64 -15zM154 237q0 -47 22 -79 l170 202q-26 14 -61 14q-59 0 -95 -40t-36 -97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 548,
    d: "M234 -12q-72 0 -123 48.5t-51 130.5v307h120v-274q0 -100 94 -100q28 0 51.5 14.5t32.5 29.5l10 14v316h120v-474h-112v69q-2 -3 -5.5 -8.5t-16.5 -19.5t-28 -24.5t-40 -19.5t-52 -9zM126 695l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 548,
    d: "M350 773l81 -79l-175 -168l-77 73zM234 -12q-72 0 -123 48.5t-51 130.5v307h120v-274q0 -100 94 -100q28 0 51.5 14.5t32.5 29.5l10 14v316h120v-474h-112v69q-2 -3 -5.5 -8.5t-16.5 -19.5t-28 -24.5t-40 -19.5t-52 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 548,
    d: "M234 -12q-72 0 -123 48.5t-51 130.5v307h120v-274q0 -100 94 -100q28 0 51.5 14.5t32.5 29.5l10 14v316h120v-474h-112v69q-2 -3 -5.5 -8.5t-16.5 -19.5t-28 -24.5t-40 -19.5t-52 -9zM89 606l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 548,
    d: "M234 -12q-72 0 -123 48.5t-51 130.5v307h120v-274q0 -100 94 -100q28 0 51.5 14.5t32.5 29.5l10 14v316h120v-474h-112v69q-2 -3 -5.5 -8.5t-16.5 -19.5t-28 -24.5t-40 -19.5t-52 -9zM94 631q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM300 631 q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 557,
    d: "M363 773l81 -79l-175 -168l-77 73zM20 -192l56 93q32 -31 63 -31t47.5 13.5t33.5 56.5l19 49l-231 485h133l160 -347l125 347h129l-230 -580q-54 -136 -178 -136q-32 0 -64 12.5t-47 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 583,
    d: "M74 756h120v-332q50 62 134 62q94 0 162.5 -71t68.5 -178t-68.5 -178t-162.5 -71q-85 0 -134 61v-279h-120v986zM194 308v-142q4 -7 11.5 -18t37 -29.5t64.5 -18.5q60 0 95 38.5t35 98.5t-35 98.5t-95 38.5q-22 0 -42 -7t-32.5 -16.5t-21.5 -19t-13 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 557,
    d: "M20 -192l56 93q32 -31 63 -31t47.5 13.5t33.5 56.5l19 49l-231 485h133l160 -347l125 347h129l-230 -580q-54 -136 -178 -136q-32 0 -64 12.5t-47 25.5zM106 631q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM312 631q0 33 23 56t56 23t56 -23t23 -56 t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 678,
    d: "M6 0l272 700h122l272 -700h-121l-64 166h-296l-64 -166h-121zM339 549l-105 -273h210zM178 790v108h322v-108h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 536,
    d: "M246 88q32 0 59.5 14t38.5 28l12 13v49q-43 24 -108 24q-34 0 -61 -16t-27 -51q0 -61 86 -61zM260 486q101 0 158.5 -47.5t57.5 -129.5v-309h-111v60q-6 -8 -17 -20t-51 -32t-88 -20q-70 0 -120.5 43t-50.5 116q0 68 54 112.5t132 44.5q39 0 72 -8.5t46 -17.5l14 -8v27 q0 42 -31.5 62t-70.5 20q-31 0 -66.5 -8.5t-55.5 -17.5l-20 -9l-39 99q88 43 187 43zM110 567v108h322v-108h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 678,
    d: "M6 0l272 700h122l272 -700h-121l-64 166h-296l-64 -166h-121zM339 549l-105 -273h210zM160 918h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5t35 -8q32 0 49.5 18t19.5 36l2 18h108q0 -7 -1 -18t-10.5 -39t-26.5 -50t-54 -39.5t-87 -17.5t-87 17t-54 41t-26.5 48t-10.5 41 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 536,
    d: "M246 88q32 0 59.5 14t38.5 28l12 13v49q-43 24 -108 24q-34 0 -61 -16t-27 -51q0 -61 86 -61zM260 486q101 0 158.5 -47.5t57.5 -129.5v-309h-111v60q-6 -8 -17 -20t-51 -32t-88 -20q-70 0 -120.5 43t-50.5 116q0 68 54 112.5t132 44.5q39 0 72 -8.5t46 -17.5l14 -8v27 q0 42 -31.5 62t-70.5 20q-31 0 -66.5 -8.5t-55.5 -17.5l-20 -9l-39 99q88 43 187 43zM89 712h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5t35 -8t35 7.5t21.5 18t10 21t3.5 17.5l1 8h108q0 -7 -1 -18t-10.5 -39t-26.5 -50t-54 -39.5t-87 -17.5t-87 17t-54 41t-26.5 48 t-10.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 678,
    d: "M6 0l272 700h122l272 -700q-4 -1 -10.5 -2.5t-24 -7.5t-30.5 -14t-23.5 -22.5t-10.5 -31.5q0 -22 13.5 -35.5t37.5 -13.5q9 0 18.5 1.5t14.5 3.5l5 2v-95q-26 -8 -51 -8q-59 0 -95 35t-36 81q0 78 67 118l-60 155h-296l-64 -166h-121zM339 549l-105 -273h210z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 536,
    d: "M260 486q99 0 157.5 -50.5t58.5 -126.5v-309q-10 -3 -25 -9t-39.5 -26t-24.5 -43q0 -22 13.5 -35.5t37.5 -13.5q9 0 18.5 1.5t14.5 3.5l5 2v-95q-26 -8 -51 -8q-59 0 -95 35t-36 81q0 37 18 66t36 40l17 11v50q-6 -8 -17 -20t-51 -32t-88 -20q-66 0 -118.5 43.5 t-52.5 115.5q0 70 52.5 113.5t130.5 43.5q40 0 73.5 -8.5t47.5 -17.5l14 -8v27q0 42 -34.5 62t-73.5 20q-33 0 -66 -9.5t-50 -19.5l-16 -9l-45 94q8 6 23 14.5t64 22.5t102 14zM246 88q32 0 59.5 14t38.5 28l12 13v51q-43 22 -108 22q-35 0 -61.5 -15t-26.5 -49t26 -49 t60 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 676,
    d: "M389 100q34 0 66.5 9t53.5 21.5t37.5 25t23.5 21.5l8 9l80 -79q-4 -5 -11 -13t-32.5 -28.5t-54.5 -36t-75 -28.5t-96 -13q-152 0 -253.5 103.5t-101.5 258.5t101.5 258.5t253.5 103.5q47 0 91 -11.5t73 -27.5t51.5 -32t33.5 -27l10 -12l-81 -79q-3 3 -7.5 8.5t-22 18.5 t-36.5 23t-49.5 18.5t-62.5 8.5q-101 0 -167 -73t-66 -177t66 -177t167 -73zM457 991l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 494,
    d: "M337 773l81 -79l-175 -168l-77 73zM283 100q23 0 43 6t33 14.5t23 17t14 14.5l4 6l79 -80q-3 -4 -8 -10t-24 -21.5t-40 -27.5t-54.5 -21.5t-69.5 -9.5q-107 0 -181 72.5t-74 176.5q0 105 74 177t181 72q56 0 104.5 -22t68.5 -44l21 -22l-83 -74q-4 6 -12.5 14t-37.5 22 t-61 14q-59 0 -96 -40t-37 -97t37 -97t96 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 676,
    d: "M389 100q34 0 66.5 9t53.5 21.5t37.5 25t23.5 21.5l8 9l80 -79q-4 -5 -11 -13t-32.5 -28.5t-54.5 -36t-75 -28.5t-96 -13q-152 0 -253.5 103.5t-101.5 258.5t101.5 258.5t253.5 103.5q47 0 91 -11.5t73 -27.5t51.5 -32t33.5 -27l10 -12l-81 -79q-3 3 -7.5 8.5t-22 18.5 t-36.5 23t-49.5 18.5t-62.5 8.5q-101 0 -167 -73t-66 -177t66 -177t167 -73zM204 824l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 497,
    d: "M95 606l186 134l186 -134l-66 -82l-120 91l-122 -91zM283 100q23 0 43 6t33 14.5t23 17t14 14.5l4 6l79 -80q-3 -4 -8 -10t-24 -21.5t-40 -27.5t-54.5 -21.5t-69.5 -9.5q-107 0 -181 72.5t-74 176.5q0 105 74 177t181 72q56 0 104.5 -22t68.5 -44l21 -22l-83 -74 q-4 6 -12.5 14t-37.5 22t-61 14q-59 0 -96 -40t-37 -97t37 -97t96 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 676,
    d: "M389 100q34 0 66.5 9t53.5 21.5t37.5 25t23.5 21.5l8 9l80 -79q-4 -5 -11 -13t-32.5 -28.5t-54.5 -36t-75 -28.5t-96 -13q-152 0 -253.5 103.5t-101.5 258.5t101.5 258.5t253.5 103.5q47 0 91 -11.5t73 -27.5t51.5 -32t33.5 -27l10 -12l-81 -79q-3 3 -7.5 8.5t-22 18.5 t-36.5 23t-49.5 18.5t-62.5 8.5q-101 0 -167 -73t-66 -177t66 -177t167 -73zM291 851q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 494,
    d: "M185 627q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM283 100q23 0 43 6t33 14.5t23 17t14 14.5l4 6l79 -80q-3 -4 -8 -10t-24 -21.5t-40 -27.5t-54.5 -21.5t-69.5 -9.5q-107 0 -181 72.5t-74 176.5q0 105 74 177t181 72q56 0 104.5 -22t68.5 -44 l21 -22l-83 -74q-4 6 -12.5 14t-37.5 22t-61 14q-59 0 -96 -40t-37 -97t37 -97t96 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 676,
    d: "M389 100q34 0 66.5 9t53.5 21.5t37.5 25t23.5 21.5l8 9l80 -79q-4 -5 -11 -13t-32.5 -28.5t-54.5 -36t-75 -28.5t-96 -13q-152 0 -253.5 103.5t-101.5 258.5t101.5 258.5t253.5 103.5q47 0 91 -11.5t73 -27.5t51.5 -32t33.5 -27l10 -12l-81 -79q-3 3 -7.5 8.5t-22 18.5 t-36.5 23t-49.5 18.5t-62.5 8.5q-101 0 -167 -73t-66 -177t66 -177t167 -73zM381 745l-186 134l66 82l120 -91l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 497,
    d: "M263 536l-186 134l66 82l120 -91l120 91l66 -82zM283 100q23 0 43 6t33 14.5t23 17t14 14.5l4 6l79 -80q-3 -4 -8 -10t-24 -21.5t-40 -27.5t-54.5 -21.5t-69.5 -9.5q-107 0 -181 72.5t-74 176.5q0 105 74 177t181 72q56 0 104.5 -22t68.5 -44l21 -22l-83 -74 q-4 6 -12.5 14t-37.5 22t-61 14q-59 0 -96 -40t-37 -97t37 -97t96 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 680,
    d: "M300 700q152 0 249 -99t97 -251t-97 -251t-249 -99h-226v700h226zM302 114q99 0 160.5 69t61.5 167q0 99 -61.5 167.5t-160.5 68.5h-108v-472h108zM316 743l-186 134l66 82l120 -91l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 705,
    d: "M513 756v-756h-111v62q-2 -3 -5 -8t-16 -18t-28 -22.5t-40 -17.5t-54 -8q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q40 0 73.5 -15.5t47.5 -30.5l13 -16v332h120zM393 166v142q-4 7 -11.5 18t-37 29.5t-64.5 18.5q-60 0 -95 -38.5t-35 -98.5t35 -98.5t95 -38.5 q22 0 42 7t32.5 16.5t21.5 19t13 16.5zM583 454v246h106v-246h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 703,
    d: "M323 700q152 0 249 -99t97 -251t-97 -251t-249 -99h-226v305h-90v104h90v291h226zM325 114q99 0 160.5 69t61.5 167q0 99 -61.5 167.5t-160.5 68.5h-108v-177h202v-104h-202v-191h108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 605,
    d: "M513 756v-101h80v-100h-80v-555h-111v62q-2 -3 -5 -8t-16 -18t-28 -22.5t-40 -17.5t-54 -8q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q40 0 73.5 -15.5t47.5 -30.5l13 -16v131h-155v100h155v101h120zM393 166v142q-4 7 -11.5 18t-37 29.5t-64.5 18.5q-60 0 -95 -38.5 t-35 -98.5t35 -98.5t95 -38.5q22 0 42 7t32.5 16.5t21.5 19t13 16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 546,
    d: "M194 586v-170h280v-114h-280v-188h310v-114h-430v700h424v-114h-304zM130 795v108h322v-108h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 533,
    d: "M107 567v108h322v-108h-322zM266 486q100 0 169.5 -70t69.5 -177q0 -27 -1 -45h-354q8 -36 44.5 -66t88.5 -30q37 0 69.5 12t46.5 24l14 12l60 -90q-8 -8 -24 -19t-65.5 -30t-100.5 -19q-108 0 -181.5 72t-73.5 177t68 177t170 72zM150 281h235q-2 36 -33.5 66t-85.5 30 q-53 0 -82.5 -29.5t-33.5 -66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 546,
    d: "M194 586v-170h280v-114h-280v-188h310v-114h-430v700h424v-114h-304zM107 918h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5t35 -8t35 7.5t21.5 18t10 21t3.5 17.5l1 8h108q0 -7 -1 -18t-10.5 -39t-26.5 -50t-54 -39.5t-87 -17.5t-87 17t-54 41t-26.5 48t-10.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 533,
    d: "M87 712h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5t35 -8t35 7.5t21.5 18t10 21t3.5 17.5l1 8h108q0 -7 -1 -18t-10.5 -39t-26.5 -50t-54 -39.5t-87 -17.5t-87 17t-54 41t-26.5 48t-10.5 41zM266 486q100 0 169.5 -70t69.5 -177q0 -27 -1 -45h-354q8 -36 44.5 -66 t88.5 -30q37 0 69.5 12t46.5 24l14 12l60 -90q-8 -8 -24 -19t-65.5 -30t-100.5 -19q-108 0 -181.5 72t-73.5 177t68 177t170 72zM150 281h235q-2 36 -33.5 66t-85.5 30q-53 0 -82.5 -29.5t-33.5 -66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 546,
    d: "M194 586v-170h280v-114h-280v-188h310v-114h-430v700h424v-114h-304zM211 851q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 533,
    d: "M187 627q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM266 486q100 0 169.5 -70t69.5 -177q0 -27 -1 -45h-354q8 -36 44.5 -66t88.5 -30q37 0 69.5 12t46.5 24l14 12l60 -90q-8 -8 -24 -19t-65.5 -30t-100.5 -19q-108 0 -181.5 72t-73.5 177t68 177 t170 72zM150 281h235q-2 36 -33.5 66t-85.5 30q-53 0 -82.5 -29.5t-33.5 -66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 546,
    d: "M194 586v-170h280v-114h-280v-188h310v-114h-430v700h424v-114h-304zM393 0h111q-10 -3 -25 -9.5t-39.5 -27t-24.5 -43.5q0 -21 13.5 -34t37.5 -13q9 0 18.5 1.5t14.5 3.5l5 2v-95q-26 -8 -51 -8q-59 0 -95 34.5t-36 79.5q0 34 18 61.5t36 37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 533,
    d: "M266 486q100 0 169.5 -70t69.5 -177q0 -27 -1 -45h-354q8 -36 44.5 -66t88.5 -30q37 0 69.5 12t46.5 24l14 12l60 -90q-43 -38 -110 -57q-11 -3 -27.5 -11t-37.5 -27t-21 -41q0 -21 13.5 -34t37.5 -13q9 0 18.5 1.5t14.5 3.5l5 2v-95q-26 -8 -51 -8q-59 0 -95 34.5 t-36 79.5q0 63 56 100q-92 14 -152 83t-60 163q0 105 68 177t170 72zM150 281h235q-2 36 -33.5 66t-85.5 30q-53 0 -82.5 -29.5t-33.5 -66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 546,
    d: "M194 586v-170h280v-114h-280v-188h310v-114h-430v700h424v-114h-304zM292 745l-186 134l66 82l120 -91l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 533,
    d: "M266 486q100 0 169.5 -70t69.5 -177q0 -27 -1 -45h-354q8 -36 44.5 -66t88.5 -30q37 0 69.5 12t46.5 24l14 12l60 -90q-8 -8 -24 -19t-65.5 -30t-100.5 -19q-108 0 -181.5 72t-73.5 177t68 177t170 72zM150 281h235q-2 36 -33.5 66t-85.5 30q-53 0 -82.5 -29.5 t-33.5 -66.5zM276 527l-186 134l66 82l120 -91l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 713,
    d: "M402 100q44 0 79.5 8.5t48.5 17.5l13 8v148h-159v112h277v-318q-4 -4 -11 -9.5t-31.5 -21t-52 -27t-72 -21t-92.5 -9.5q-155 0 -261.5 104t-106.5 258q0 155 104.5 258.5t258.5 103.5q48 0 92.5 -11t73.5 -26t51 -30.5t32 -26.5l10 -11l-82 -80q-2 3 -7 8t-21 17.5 t-35 22t-50 17.5t-64 8q-104 0 -172.5 -73.5t-68.5 -176.5t71 -176.5t175 -73.5zM209 824l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 573,
    d: "M393 49q-49 -61 -134 -61q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62h111v-478q0 -117 -73.5 -177.5t-181.5 -60.5q-60 0 -116.5 22.5t-82.5 45.5l-26 22l68 92q7 -8 20.5 -19.5t55 -31t81.5 -19.5q67 0 101 33t34 89v57z M393 166v142q-4 7 -11.5 18t-37 29.5t-64.5 18.5q-60 0 -95 -38.5t-35 -98.5t35 -98.5t95 -38.5q35 0 63 16.5t39 33.5zM101 605l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 713,
    d: "M402 100q44 0 79.5 8.5t48.5 17.5l13 8v148h-159v112h277v-318q-4 -4 -11 -9.5t-31.5 -21t-52 -27t-72 -21t-92.5 -9.5q-155 0 -261.5 104t-106.5 258q0 155 104.5 258.5t258.5 103.5q48 0 92.5 -11t73.5 -26t51 -30.5t32 -26.5l10 -11l-82 -80q-2 3 -7 8t-21 17.5 t-35 22t-50 17.5t-64 8q-104 0 -172.5 -73.5t-68.5 -176.5t71 -176.5t175 -73.5zM203 928h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5t35 -8t35 7.5t21.5 18t10 21t3.5 17.5l1 8h108q0 -7 -1 -18t-10.5 -39t-26.5 -50t-54 -39.5t-87 -17.5t-87 17t-54 41t-26.5 48t-10.5 41 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 573,
    d: "M393 49q-49 -61 -134 -61q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62h111v-478q0 -117 -73.5 -177.5t-181.5 -60.5q-60 0 -116.5 22.5t-82.5 45.5l-26 22l68 92q7 -8 20.5 -19.5t55 -31t81.5 -19.5q67 0 101 33t34 89v57z M393 166v142q-4 7 -11.5 18t-37 29.5t-64.5 18.5q-60 0 -95 -38.5t-35 -98.5t35 -98.5t95 -38.5q35 0 63 16.5t39 33.5zM100 712h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5t35 -8q32 0 49.5 18t19.5 36l2 18h108q0 -7 -1 -18t-10.5 -39t-26.5 -50t-54 -39.5t-87 -17.5 t-87 17t-54 41t-26.5 48t-10.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 713,
    d: "M402 100q44 0 79.5 8.5t48.5 17.5l13 8v148h-159v112h277v-318q-4 -4 -11 -9.5t-31.5 -21t-52 -27t-72 -21t-92.5 -9.5q-155 0 -261.5 104t-106.5 258q0 155 104.5 258.5t258.5 103.5q48 0 92.5 -11t73.5 -26t51 -30.5t32 -26.5l10 -11l-82 -80q-2 3 -7 8t-21 17.5 t-35 22t-50 17.5t-64 8q-104 0 -172.5 -73.5t-68.5 -176.5t71 -176.5t175 -73.5zM304 851q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 573,
    d: "M393 49q-49 -61 -134 -61q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62h111v-478q0 -117 -73.5 -177.5t-181.5 -60.5q-60 0 -116.5 22.5t-82.5 45.5l-26 22l68 92q7 -8 20.5 -19.5t55 -31t81.5 -19.5q67 0 101 33t34 89v57z M393 166v142q-4 7 -11.5 18t-37 29.5t-64.5 18.5q-60 0 -95 -38.5t-35 -98.5t35 -98.5t95 -38.5q35 0 63 16.5t39 33.5zM198 627q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcedilla",
    unicode: "\u0122",
    horizAdvX: 713,
    d: "M402 100q44 0 79.5 8.5t48.5 17.5l13 8v148h-159v112h277v-318q-4 -4 -11 -9.5t-31.5 -21t-52 -27t-72 -21t-92.5 -9.5q-155 0 -261.5 104t-106.5 258q0 155 104.5 258.5t258.5 103.5q48 0 92.5 -11t73.5 -26t51 -30.5t32 -26.5l10 -11l-82 -80q-2 3 -7 8t-21 17.5 t-35 22t-50 17.5t-64 8q-104 0 -172.5 -73.5t-68.5 -176.5t71 -176.5t175 -73.5zM448 -57l-68 -214l-111 32l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcedilla",
    unicode: "\u0123",
    horizAdvX: 573,
    d: "M393 49q-49 -61 -134 -61q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62h111v-478q0 -117 -73.5 -177.5t-181.5 -60.5q-60 0 -116.5 22.5t-82.5 45.5l-26 22l68 92q7 -8 20.5 -19.5t55 -31t81.5 -19.5q67 0 101 33t34 89v57z M393 166v142q-4 7 -11.5 18t-37 29.5t-64.5 18.5q-60 0 -95 -38.5t-35 -98.5t35 -98.5t95 -38.5q35 0 63 16.5t39 33.5zM210 554l68 214l111 -32l-72 -194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 687,
    d: "M493 415v285h120v-700h-120v301h-299v-301h-120v700h120v-285h299zM157 824l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 562,
    d: "M328 486q72 0 123 -48.5t51 -130.5v-307h-120v277q0 49 -26 73t-68 24q-17 0 -33 -6.5t-27 -15.5t-19 -18t-11 -16l-4 -6v-312h-120v756h120v-339l5 7.5t15.5 16.5t26.5 21t37.5 16.5t49.5 7.5zM-52 864l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 701,
    d: "M8 606h73v94h120v-94h299v94h120v-94h73v-100h-73v-506h-120v301h-299v-301h-120v506h-73v100zM500 415v91h-299v-91h299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 576,
    d: "M8 555v100h80v101h120v-101h145v-100h-145v-138l5 7.5t15.5 16.5t26.5 21t37.5 16.5t49.5 7.5q72 0 123 -48.5t51 -130.5v-307h-120v277q0 49 -26 73t-68 24q-28 0 -51.5 -16t-32.5 -32l-10 -15v-311h-120v555h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 296,
    d: "M88 0v700h120v-700h-120zM28 765l-84 61q1 4 4 11t14.5 25t25.5 32t38 25t52 11q32 0 76.5 -29t60.5 -29q19 0 32.5 16t17.5 32l4 17l82 -65q-1 -4 -4 -11.5t-14 -25.5t-24.5 -32t-37 -25.5t-50.5 -11.5q-31 0 -75.5 28.5t-61.5 28.5q-19 0 -33 -14.5t-19 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 343,
    d: "M112 0v462h120v-462h-120zM52 527l-84 61q1 4 4 11t14.5 25t25.5 32t38 25t52 11q32 0 76.5 -29t60.5 -29q19 0 32.5 16t17.5 32l4 17l82 -65q-1 -4 -4 -11.5t-14 -25.5t-24.5 -32t-37 -25.5t-50.5 -11.5q-32 0 -76.5 28.5t-60.5 28.5q-19 0 -33 -14.5t-19 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 296,
    d: "M88 0v700h120v-700h-120zM-13 790v108h322v-108h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 286,
    d: "M82 0v462h120v-462h-120zM-18 568v108h322v-108h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 296,
    d: "M88 0v700h120v-700h-120zM-31 918h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5t35 -8q32 0 49.5 18t19.5 36l2 18h108q0 -7 -1 -18t-10.5 -39t-26.5 -50t-54 -39.5t-87 -17.5t-87 17t-54 41t-26.5 48t-10.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 294,
    d: "M85 0v462h120v-462h-120zM-32 712h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5t35 -8q32 0 49.5 18t19.5 36l2 18h108q0 -7 -1 -18t-10.5 -39t-26.5 -50t-54 -39.5t-87 -17.5t-87 17t-54 41t-26.5 48t-10.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 296,
    d: "M26 -107q0 42 19.5 70t42.5 42v695h120v-700q-10 -3 -25 -9t-39.5 -26t-24.5 -43q0 -22 13.5 -35.5t37.5 -13.5q9 0 18.5 1.5t14.5 3.5l5 2v-95q-26 -8 -51 -8q-59 0 -95 35t-36 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 278,
    d: "M17 -107q0 41 20 69.5t42 42.5v469h120v-474h-1q-8 -2 -25 -9t-40 -27t-23 -42t14 -35.5t37 -13.5q9 0 18.5 1.5t14.5 3.5l5 2v-95q-26 -8 -51 -8q-59 0 -95 35t-36 81zM60 627q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 296,
    d: "M89 0v700h120v-700h-120zM69 835q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 278,
    d: "M79 0v462h120v-462h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 748,
    d: "M88 0v700h120v-700h-120zM554 216v484h120v-480q0 -110 -63.5 -171t-175.5 -61q-39 0 -74.5 12t-58.5 29t-40 34.5t-24 29.5l-8 12l88 74q2 -3 5.5 -8.5t15 -18.5t24 -23t32.5 -18.5t40 -8.5q63 0 91 33.5t28 80.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 494,
    d: "M79 0v474h120v-474h-120zM60 627q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM127 -211l43 101q31 -20 57 -20q13 0 22.5 2.5t21.5 11.5t18.5 30.5t6.5 53.5v506h120v-517q0 -55 -17 -96t-44.5 -62t-56.5 -31t-58 -10t-57.5 8t-42.5 16zM276 627 q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 521,
    d: "M327 216v484h120v-480q0 -110 -63.5 -171t-175.5 -61q-39 0 -74.5 12t-58.5 29t-40 34.5t-25 29.5l-7 12l88 74q2 -3 5.5 -8.5t15 -18.5t24 -23t32.5 -18.5t40 -8.5q63 0 91 33.5t28 80.5zM201 821l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 331,
    d: "M-35 -211l44 100q28 -19 50 -19q15 0 25.5 2.5t23 11.5t19 30t6.5 54v506h120v-517q0 -55 -17 -96t-44.5 -62t-56.5 -31t-58 -10q-60 0 -112 31zM7 618l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcedilla",
    unicode: "\u0136",
    horizAdvX: 628,
    d: "M194 700v-314l250 314h150l-274 -344l308 -356h-159l-275 316v-316h-120v700h120zM374 -47l-68 -214l-111 32l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcedilla",
    unicode: "\u0137",
    horizAdvX: 535,
    d: "M194 756v-469l170 187h155l-208 -224l222 -250h-158l-181 207v-207h-120v756h120zM349 -57l-68 -214l-111 32l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 521,
    d: "M361 0l-181 207v-207h-120v474h120v-186l170 186h155l-208 -224l222 -250h-158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 500,
    d: "M74 0v700h120v-586h298v-114h-418zM191 991l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 268,
    d: "M74 0v756h120v-756h-120zM191 1033l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcedilla",
    unicode: "\u013B",
    horizAdvX: 500,
    d: "M74 0v700h120v-586h298v-114h-418zM342 -57l-68 -214l-111 32l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcedilla",
    unicode: "\u013C",
    horizAdvX: 268,
    d: "M74 0v756h120v-756h-120zM213 -57l-68 -214l-111 32l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 500,
    d: "M74 0v700h120v-586h298v-114h-418zM281 454v246h106v-246h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 387,
    d: "M74 0v756h120v-756h-120zM265 454v246h106v-246h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 500,
    d: "M74 0v700h120v-586h298v-114h-418zM263 370q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 394,
    d: "M74 0v756h120v-756h-120zM230 370q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 541,
    d: "M56 147l-50 67l110 86v400h120v-307l170 133l50 -67l-220 -172v-173h297v-114h-417v194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 360,
    d: "M56 213l-50 67l112 87v389h120v-296l66 52l50 -67l-116 -91v-354h-120v261z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 726,
    d: "M74 700h108l350 -482v482h120v-700h-108l-350 481v-481h-120v700zM464 991l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 548,
    d: "M314 486q72 0 123 -48.5t51 -130.5v-307h-120v277q0 49 -26 73t-68 24q-17 0 -33 -6.5t-27 -15t-19 -17.5t-11 -15l-4 -7v-313h-120v474h112v-69q2 3 5.5 8.5t16 19.5t27.5 24.5t40 19.5t53 9zM338 773l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncedilla",
    unicode: "\u0145",
    horizAdvX: 726,
    d: "M74 700h108l350 -482v482h120v-700h-108l-350 481v-481h-120v700zM416 -47l-68 -214l-111 32l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncedilla",
    unicode: "\u0146",
    horizAdvX: 548,
    d: "M314 486q72 0 123 -48.5t51 -130.5v-307h-120v277q0 49 -26 73t-68 24q-17 0 -33 -6.5t-27 -15t-19 -17.5t-11 -15l-4 -7v-313h-120v474h112v-69q2 3 5.5 8.5t16 19.5t27.5 24.5t40 19.5t53 9zM350 -47l-68 -214l-111 32l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 726,
    d: "M74 700h108l350 -482v482h120v-700h-108l-350 481v-481h-120v700zM367 741l-186 134l66 82l120 -91l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 548,
    d: "M314 486q72 0 123 -48.5t51 -130.5v-307h-120v277q0 49 -26 73t-68 24q-17 0 -33 -6.5t-27 -15t-19 -17.5t-11 -15l-4 -7v-313h-120v474h112v-69q2 3 5.5 8.5t16 19.5t27.5 24.5t40 19.5t53 9zM278 527l-186 134l66 82l120 -91l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 656,
    d: "M422 486q72 0 123 -48.5t51 -130.5v-307h-120v277q0 49 -26 73t-68 24q-17 0 -33 -6.5t-27 -15t-19 -17.5t-11 -15l-4 -7v-313h-120v474h112v-69q2 3 5.5 8.5t16 19.5t27.5 24.5t40 19.5t53 9zM12 454v246h106v-246h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 726,
    d: "M74 700h108l350 -482v482h120v-743q0 -55 -17 -96t-44.5 -62t-56.5 -31t-58 -10q-60 0 -112 31l44 100q28 -19 50 -19q15 0 25.5 2.5t23 11.5t19 30t6.5 54v48l-338 465v-481h-120v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 548,
    d: "M314 486q72 0 123 -48.5t51 -130.5v-350q0 -55 -17 -96t-44.5 -62t-56.5 -31t-58 -10q-60 0 -112 31l44 100q28 -19 50 -19q15 0 25.5 2.5t23 11.5t19 30t6.5 54v309q0 49 -26 73t-68 24q-28 0 -51.5 -16t-32.5 -32l-10 -15v-311h-120v474h112v-69q2 3 5.5 8.5t16 19.5 t27.5 24.5t40 19.5t53 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 776,
    d: "M388 712q153 0 253.5 -103t100.5 -259t-100.5 -259t-253.5 -103t-253.5 103t-100.5 259t100.5 259t253.5 103zM388 102q103 0 167.5 72t64.5 176t-64.5 176t-167.5 72t-167.5 -72t-64.5 -176t64.5 -176t167.5 -72zM227 790v108h322v-108h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 562,
    d: "M281 486q106 0 179.5 -72t73.5 -177q0 -104 -73.5 -176.5t-179.5 -72.5t-179.5 72.5t-73.5 176.5q0 105 73.5 177t179.5 72zM281 100q59 0 95 40t36 97t-36 97t-95 40t-95 -40t-36 -97t36 -97t95 -40zM120 568v108h322v-108h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 776,
    d: "M388 712q153 0 253.5 -103t100.5 -259t-100.5 -259t-253.5 -103t-253.5 103t-100.5 259t100.5 259t253.5 103zM388 102q103 0 167.5 72t64.5 176t-64.5 176t-167.5 72t-167.5 -72t-64.5 -176t64.5 -176t167.5 -72zM209 928h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5 t35 -8t35 7.5t21.5 18t10 21t3.5 17.5l1 8h108q0 -7 -1 -18t-10.5 -39t-26.5 -50t-54 -39.5t-87 -17.5t-87 17t-54 41t-26.5 48t-10.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 562,
    d: "M281 486q106 0 179.5 -72t73.5 -177q0 -104 -73.5 -176.5t-179.5 -72.5t-179.5 72.5t-73.5 176.5q0 105 73.5 177t179.5 72zM281 100q59 0 95 40t36 97t-36 97t-95 40t-95 -40t-36 -97t36 -97t95 -40zM102 712h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5t35 -8 q32 0 49.5 18t19.5 36l2 18h108q0 -7 -1 -18t-10.5 -39t-26.5 -50t-54 -39.5t-87 -17.5t-87 17t-54 41t-26.5 48t-10.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 776,
    d: "M388 712q153 0 253.5 -103t100.5 -259t-100.5 -259t-253.5 -103t-253.5 103t-100.5 259t100.5 259t253.5 103zM388 102q103 0 167.5 72t64.5 176t-64.5 176t-167.5 72t-167.5 -72t-64.5 -176t64.5 -176t167.5 -72zM367 981l84 -54l-128 -177l-76 47zM536 981l84 -54 l-128 -177l-76 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 562,
    d: "M281 486q106 0 179.5 -72t73.5 -177q0 -104 -73.5 -176.5t-179.5 -72.5t-179.5 72.5t-73.5 176.5q0 105 73.5 177t179.5 72zM281 100q59 0 95 40t36 97t-36 97t-95 40t-95 -40t-36 -97t36 -97t95 -40zM239 747l84 -54l-128 -177l-76 47zM408 747l84 -54l-128 -177l-76 47 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 826,
    d: "M524 588v-172h230v-114h-230v-190h260v-112h-405q-147 0 -248 100.5t-101 249.5t101 249.5t248 100.5h399v-112h-254zM404 112v476h-25q-98 0 -162.5 -69.5t-64.5 -168.5q0 -98 64.5 -168t162.5 -70h25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 916,
    d: "M653 486q103 0 169 -69t66 -178q0 -26 -1 -44h-351q8 -36 44 -66.5t88 -30.5q37 0 69.5 12t46.5 24l14 12l60 -90q-8 -8 -24 -19t-65.5 -30t-100.5 -19q-121 0 -196 86q-73 -86 -192 -86q-105 0 -178.5 72.5t-73.5 176.5q0 105 73.5 177t178.5 72q115 0 190 -85 q70 85 183 85zM280 100q59 0 95.5 40t36.5 97t-36.5 97t-95.5 40t-95.5 -40t-36.5 -97t36.5 -97t95.5 -40zM536 280h233q-2 36 -32 66.5t-84 30.5q-53 0 -83 -30t-34 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 583,
    d: "M74 0v700h230q104 0 168 -61t64 -157q0 -80 -41 -135.5t-115 -74.5l175 -272h-140l-166 264h-55v-264h-120zM289 378q59 0 92 26.5t33 77.5t-33 77.5t-92 26.5h-95v-208h95zM355 991l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 387,
    d: "M303 486q19 0 39.5 -4t31.5 -8l11 -3l-42 -108q-22 11 -57 11q-32 0 -58.5 -16t-37.5 -32l-10 -16v-310h-120v474h114v-69q2 3 5 8.5t15 19.5t25.5 24.5t36 19.5t47.5 9zM253 773l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcedilla",
    unicode: "\u0156",
    horizAdvX: 583,
    d: "M74 0v700h230q104 0 168 -61t64 -157q0 -80 -41 -135.5t-115 -74.5l175 -272h-140l-166 264h-55v-264h-120zM289 378q59 0 92 26.5t33 77.5t-33 77.5t-92 26.5h-95v-208h95zM369 -47l-68 -214l-111 32l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcedilla",
    unicode: "\u0157",
    horizAdvX: 387,
    d: "M303 486q19 0 39.5 -4t31.5 -8l11 -3l-42 -108q-22 11 -57 11q-32 0 -58.5 -16t-37.5 -32l-10 -16v-310h-120v474h114v-69q2 3 5 8.5t15 19.5t25.5 24.5t36 19.5t47.5 9zM210 -57l-68 -214l-111 32l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 583,
    d: "M74 0v700h230q104 0 168 -61t64 -157q0 -80 -41 -135.5t-115 -74.5l175 -272h-140l-166 264h-55v-264h-120zM289 378q59 0 92 26.5t33 77.5t-33 77.5t-92 26.5h-95v-208h95zM297 751l-186 134l66 82l120 -91l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 387,
    d: "M303 486q19 0 39.5 -4t31.5 -8l11 -3l-42 -108q-22 11 -57 11q-32 0 -58.5 -16t-37.5 -32l-10 -16v-310h-120v474h114v-69q2 3 5 8.5t15 19.5t25.5 24.5t36 19.5t47.5 9zM206 527l-186 134l66 82l120 -91l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 595,
    d: "M424 183q0 41 -29 62.5t-99 46.5q-45 16 -78.5 32.5t-68.5 42.5t-53.5 63.5t-18.5 83.5q0 78 64 138t165 60q41 0 79.5 -11.5t64 -28t45.5 -32.5t29 -28l10 -11l-83 -82q-2 3 -6.5 8.5t-19.5 19t-30.5 24t-40 19t-48.5 8.5q-45 0 -76 -24.5t-31 -59.5q0 -28 20.5 -49.5 t41.5 -31t82 -32.5q5 -2 7 -3q46 -17 77 -33t60.5 -41t44 -60t14.5 -81q0 -92 -70 -143.5t-174 -51.5q-49 0 -93.5 14.5t-72.5 35.5t-49.5 42.5t-30.5 35.5l-10 15l90 76q2 -4 7 -11t21 -25.5t34 -32t46 -25t58 -11.5q50 0 86 20.5t36 60.5zM371 991l81 -79l-175 -168 l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 483,
    d: "M30 74l67 87q7 -8 19.5 -19t50 -30t73.5 -19q39 0 64.5 11t25.5 32q0 22 -18 31t-76 21q-176 37 -176 150q0 59 55.5 103.5t148.5 44.5q48 0 92.5 -14.5t65.5 -29.5l20 -14l-60 -88q-54 41 -118 41q-36 0 -61 -12t-25 -33q0 -20 22 -29.5t90 -23.5q80 -17 120.5 -49 t40.5 -100q0 -62 -58.5 -104t-148.5 -42q-39 0 -75.5 9t-60.5 21.5t-42.5 25t-27.5 21.5zM325 773l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 595,
    d: "M424 183q0 41 -29 62.5t-99 46.5q-45 16 -78.5 32.5t-68.5 42.5t-53.5 63.5t-18.5 83.5q0 78 64 138t165 60q41 0 79.5 -11.5t64 -28t45.5 -32.5t29 -28l10 -11l-83 -82q-2 3 -6.5 8.5t-19.5 19t-30.5 24t-40 19t-48.5 8.5q-45 0 -76 -24.5t-31 -59.5q0 -28 20.5 -49.5 t41.5 -31t82 -32.5q5 -2 7 -3q46 -17 77 -33t60.5 -41t44 -60t14.5 -81q0 -92 -70 -143.5t-174 -51.5q-49 0 -93.5 14.5t-72.5 35.5t-49.5 42.5t-30.5 35.5l-10 15l90 76q2 -4 7 -11t21 -25.5t34 -32t46 -25t58 -11.5q50 0 86 20.5t36 60.5zM130 824l186 134l186 -134 l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 483,
    d: "M30 74l67 87q7 -8 19.5 -19t50 -30t73.5 -19q39 0 64.5 11t25.5 32q0 22 -18 31t-76 21q-176 37 -176 150q0 59 55.5 103.5t148.5 44.5q48 0 92.5 -14.5t65.5 -29.5l20 -14l-60 -88q-54 41 -118 41q-36 0 -61 -12t-25 -33q0 -20 22 -29.5t90 -23.5q80 -17 120.5 -49 t40.5 -100q0 -62 -58.5 -104t-148.5 -42q-39 0 -75.5 9t-60.5 21.5t-42.5 25t-27.5 21.5zM77 605l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 595,
    d: "M424 183q0 41 -29 62.5t-99 46.5q-45 16 -78.5 32.5t-68.5 42.5t-53.5 63.5t-18.5 83.5q0 78 64 138t165 60q41 0 79.5 -11.5t64 -28t45.5 -32.5t29 -28l10 -11l-83 -82q-2 3 -6.5 8.5t-19.5 19t-30.5 24t-40 19t-48.5 8.5q-45 0 -76 -24.5t-31 -59.5q0 -28 20.5 -49.5 t41.5 -31t82 -32.5q5 -2 7 -3q46 -17 77 -33t60.5 -41t44 -60t14.5 -81q0 -92 -70 -143.5t-174 -51.5q-49 0 -93.5 14.5t-72.5 35.5t-49.5 42.5t-30.5 35.5l-10 15l90 76q2 -4 7 -11t21 -25.5t34 -32t46 -25t58 -11.5q50 0 86 20.5t36 60.5zM348 -57l-68 -214l-111 32 l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 483,
    d: "M30 74l67 87q7 -8 19.5 -19t50 -30t73.5 -19q39 0 64.5 11t25.5 32q0 22 -18 31t-76 21q-176 37 -176 150q0 59 55.5 103.5t148.5 44.5q48 0 92.5 -14.5t65.5 -29.5l20 -14l-60 -88q-54 41 -118 41q-36 0 -61 -12t-25 -33q0 -20 22 -29.5t90 -23.5q80 -17 120.5 -49 t40.5 -100q0 -62 -58.5 -104t-148.5 -42q-39 0 -75.5 9t-60.5 21.5t-42.5 25t-27.5 21.5zM303 -57l-68 -214l-111 32l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 595,
    d: "M424 183q0 41 -29 62.5t-99 46.5q-45 16 -78.5 32.5t-68.5 42.5t-53.5 63.5t-18.5 83.5q0 78 64 138t165 60q41 0 79.5 -11.5t64 -28t45.5 -32.5t29 -28l10 -11l-83 -82q-2 3 -6.5 8.5t-19.5 19t-30.5 24t-40 19t-48.5 8.5q-45 0 -76 -24.5t-31 -59.5q0 -28 20.5 -49.5 t41.5 -31t82 -32.5q5 -2 7 -3q46 -17 77 -33t60.5 -41t44 -60t14.5 -81q0 -92 -70 -143.5t-174 -51.5q-49 0 -93.5 14.5t-72.5 35.5t-49.5 42.5t-30.5 35.5l-10 15l90 76q2 -4 7 -11t21 -25.5t34 -32t46 -25t58 -11.5q50 0 86 20.5t36 60.5zM317 745l-186 134l66 82l120 -91 l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 483,
    d: "M30 74l67 87q7 -8 19.5 -19t50 -30t73.5 -19q39 0 64.5 11t25.5 32q0 22 -18 31t-76 21q-176 37 -176 150q0 59 55.5 103.5t148.5 44.5q48 0 92.5 -14.5t65.5 -29.5l20 -14l-60 -88q-54 41 -118 41q-36 0 -61 -12t-25 -33q0 -20 22 -29.5t90 -23.5q80 -17 120.5 -49 t40.5 -100q0 -62 -58.5 -104t-148.5 -42q-39 0 -75.5 9t-60.5 21.5t-42.5 25t-27.5 21.5zM262 526l-186 134l66 82l120 -91l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcedilla",
    unicode: "\u0162",
    horizAdvX: 534,
    d: "M207 0v586h-193v114h506v-114h-193v-586h-120zM324 -57l-68 -214l-111 32l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcedilla",
    unicode: "\u0163",
    horizAdvX: 416,
    d: "M22 366v108h93v141h120v-141h143v-108h-143v-191q0 -75 62 -75q12 0 24.5 4t18.5 8l7 5l44 -98q-45 -31 -114 -31q-70 0 -116 46.5t-46 121.5v210h-93zM292 -57l-68 -214l-111 32l72 194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 534,
    d: "M207 0v586h-193v114h506v-114h-193v-586h-120zM267 743l-186 134l66 82l120 -91l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 428,
    d: "M22 366v108h93v141h120v-141h143v-108h-143v-191q0 -75 62 -75q12 0 24.5 4t18.5 8l7 5l44 -98q-45 -31 -114 -31q-70 0 -116 46.5t-46 121.5v210h-93zM310 534v246h106v-246h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 534,
    d: "M84 374v100h123v112h-193v114h506v-114h-193v-112h123v-100h-123v-374h-120v374h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 406,
    d: "M22 368v106h83v141h120v-141h143v-106h-143v-78h143v-100h-143v-15q0 -75 63 -75q12 0 24 4t18 8l7 5l44 -98q-45 -31 -114 -31q-71 0 -116.5 45t-45.5 123v34h-83v100h83v78h-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 688,
    d: "M494 269v431h120v-446q0 -117 -74 -191.5t-196 -74.5t-196 74.5t-74 191.5v446h120v-431q0 -77 38.5 -122t111.5 -45t111.5 45t38.5 122zM224 775l-84 61q1 4 4 11t14.5 25t25.5 32t38 25t52 11q32 0 76.5 -29t60.5 -29q19 0 32.5 16t17.5 32l4 17l82 -65q-1 -4 -4 -11.5 t-14 -25.5t-24.5 -32t-37 -25.5t-50.5 -11.5q-31 0 -76 28.5t-61 28.5q-19 0 -33 -14.5t-19 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 548,
    d: "M234 -12q-72 0 -123 48.5t-51 130.5v307h120v-274q0 -100 94 -100q28 0 51.5 14.5t32.5 29.5l10 14v316h120v-474h-112v69q-2 -3 -5.5 -8.5t-16.5 -19.5t-28 -24.5t-40 -19.5t-52 -9zM155 554l-84 61q1 4 4 11t14.5 25t25.5 32t38 25t52 11q32 0 76.5 -29t60.5 -29 q19 0 32.5 16.5t17.5 32.5l4 16l82 -65q-1 -4 -4 -11.5t-14 -25.5t-24.5 -32t-37 -25.5t-50.5 -11.5q-32 0 -76.5 28.5t-60.5 28.5q-19 0 -33 -14.5t-18 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 688,
    d: "M494 269v431h120v-446q0 -117 -74 -191.5t-196 -74.5t-196 74.5t-74 191.5v446h120v-431q0 -77 38.5 -122t111.5 -45t111.5 45t38.5 122zM183 800v108h322v-108h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 548,
    d: "M234 -12q-72 0 -123 48.5t-51 130.5v307h120v-274q0 -100 94 -100q28 0 51.5 14.5t32.5 29.5l10 14v316h120v-474h-112v69q-2 -3 -5.5 -8.5t-16.5 -19.5t-28 -24.5t-40 -19.5t-52 -9zM115 577v108h322v-108h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 688,
    d: "M494 269v431h120v-446q0 -117 -74 -191.5t-196 -74.5t-196 74.5t-74 191.5v446h120v-431q0 -77 38.5 -122t111.5 -45t111.5 45t38.5 122zM162 918h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5t35 -8q32 0 49.5 18t19.5 36l2 18h108q0 -7 -1 -18t-10.5 -39t-26.5 -50 t-54 -39.5t-87 -17.5t-87 17t-54 41t-26.5 48t-10.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 548,
    d: "M234 -12q-72 0 -123 48.5t-51 130.5v307h120v-274q0 -100 94 -100q28 0 51.5 14.5t32.5 29.5l10 14v316h120v-474h-112v69q-2 -3 -5.5 -8.5t-16.5 -19.5t-28 -24.5t-40 -19.5t-52 -9zM91 700h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5t35 -8t35 7.5t21.5 18t10 21 t3.5 17.5l1 8h108q0 -7 -1 -18t-10.5 -39t-26.5 -50t-54 -39.5t-87 -17.5t-87 17t-54 41t-26.5 48t-10.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 688,
    d: "M494 269v431h120v-446q0 -117 -74 -191.5t-196 -74.5t-196 74.5t-74 191.5v446h120v-431q0 -77 38.5 -122t111.5 -45t111.5 45t38.5 122zM222 850q0 49 36 84.5t86 35.5t86 -35.5t36 -84.5t-36 -84.5t-86 -35.5t-86 35.5t-36 84.5zM290 850q0 -22 16 -38t38 -16t38 16 t16 38t-16 38t-38 16t-38 -16t-16 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 548,
    d: "M234 -12q-72 0 -123 48.5t-51 130.5v307h120v-274q0 -100 94 -100q28 0 51.5 14.5t32.5 29.5l10 14v316h120v-474h-112v69q-2 -3 -5.5 -8.5t-16.5 -19.5t-28 -24.5t-40 -19.5t-52 -9zM152 648q0 49 36 84.5t86 35.5t86 -35.5t36 -84.5t-36 -84.5t-86 -35.5t-86 35.5 t-36 84.5zM220 648q0 -22 16 -38t38 -16t38 16t16 38t-16 38t-38 16t-38 -16t-16 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 688,
    d: "M494 269v431h120v-446q0 -117 -74 -191.5t-196 -74.5t-196 74.5t-74 191.5v446h120v-431q0 -77 38.5 -122t111.5 -45t111.5 45t38.5 122zM312 983l84 -54l-128 -177l-76 47zM481 983l84 -54l-128 -177l-76 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 548,
    d: "M234 -12q-72 0 -123 48.5t-51 130.5v307h120v-274q0 -100 94 -100q28 0 51.5 14.5t32.5 29.5l10 14v316h120v-474h-112v69q-2 -3 -5.5 -8.5t-16.5 -19.5t-28 -24.5t-40 -19.5t-52 -9zM245 745l84 -54l-128 -177l-76 47zM414 745l84 -54l-128 -177l-76 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 688,
    d: "M494 269v431h120v-446q0 -94 -49.5 -162.5t-134.5 -91.5q-12 -4 -28 -11.5t-37.5 -27.5t-21.5 -41t13.5 -34t37.5 -13q9 0 18.5 1.5t14.5 3.5l5 2v-95q-26 -8 -51 -8q-59 0 -95 34.5t-36 79.5q0 61 54 100q-106 12 -168 84t-62 179v446h120v-431q0 -77 38.5 -122 t111.5 -45t111.5 45t38.5 122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 548,
    d: "M234 -12q-72 0 -123 48.5t-51 130.5v307h120v-274q0 -100 94 -100q28 0 51.5 14.5t32.5 29.5l10 14v316h120v-474h-1q-8 -2 -25 -9t-40 -27t-23 -42t13.5 -35.5t37.5 -13.5q9 0 18.5 1.5t14.5 3.5l5 2v-95q-26 -8 -51 -8q-59 0 -95 35t-36 81q0 35 18 64t30.5 38t21.5 14 v60q-2 -3 -5.5 -8.5t-16.5 -19.5t-28 -24.5t-40 -19.5t-52 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 983,
    d: "M979 700l-276 -724l-210 525l-213 -525l-276 724h136l148 -420l159 420h99l156 -420l152 420h125zM305 824l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 768,
    d: "M4 474h134l98 -243l103 243h101l100 -243l102 243h122l-229 -498l-152 338l-150 -338zM203 606l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 614,
    d: "M367 276v-276h-120v276l-239 424h132l171 -313l171 313h124zM121 824l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 557,
    d: "M20 -192l56 93q32 -31 63 -31t47.5 13.5t33.5 56.5l19 49l-231 485h133l160 -347l125 347h129l-230 -580q-54 -136 -178 -136q-32 0 -64 12.5t-47 25.5zM98 605l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 614,
    d: "M367 276v-276h-120v276l-239 424h132l171 -313l171 313h124zM125 851q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM331 851q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 597,
    d: "M48 700h535l-364 -586h344v-114h-549l366 586h-332v114zM379 998l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 495,
    d: "M47 474h422l-235 -362h224v-112h-428l235 362h-218v112zM312 773l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 597,
    d: "M48 700h535l-364 -586h344v-114h-549l366 586h-332v114zM220 841q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 495,
    d: "M47 474h422l-235 -362h224v-112h-428l235 362h-218v112zM172 627q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 597,
    d: "M48 700h535l-364 -586h344v-114h-549l366 586h-332v114zM319 746l-186 134l66 82l120 -91l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 495,
    d: "M47 474h422l-235 -362h224v-112h-428l235 362h-218v112zM260 526l-186 134l66 82l120 -91l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "longs",
    unicode: "\u017F",
    horizAdvX: 342,
    d: "M16 364v110h93v114q0 91 51.5 135.5t118.5 44.5q29 0 55.5 -6t37.5 -12l12 -7l-45 -99q-17 14 -48 14q-23 0 -42.5 -16t-19.5 -57v-585h-120v364h-93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    d: "M351 366l-58 -330q-15 -91 -73 -137t-146 -46h-52v112h40q61 0 87 29t35 81l51 291h-90l18 108h90l27 147q13 71 62.5 109t120.5 38q23 0 49 -6t40 -12l14 -7l-45 -103q-21 16 -50 16q-69 0 -82 -74l-20 -108h114l-18 -108h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophemod",
    unicode: "\u02BC",
    horizAdvX: 186,
    d: "M40 454v246h106v-246h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 424,
    d: "M26 596l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 424,
    d: "M212 513l-186 134l66 82l120 -91l120 91l66 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 410,
    d: "M26 700h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5t35 -8q32 0 49.5 18t19.5 36l2 18h108q0 -7 -1 -18t-10.5 -39t-26.5 -50t-54 -39.5t-87 -17.5t-87 17t-54 41t-26.5 48t-10.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 240,
    d: "M41 623q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 256,
    d: "M6 643q0 49 36 84.5t86 35.5t86 -35.5t36 -84.5t-36 -84.5t-86 -35.5t-86 35.5t-36 84.5zM74 643q0 -23 16 -38.5t38 -15.5t38 15.5t16 38.5t-16 38.5t-38 15.5t-38 -15.5t-16 -38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 256,
    d: "M85 0h111q-10 -3 -25 -9.5t-39.5 -27t-24.5 -43.5q0 -21 13.5 -34t37.5 -13q9 0 18.5 1.5t14.5 3.5l5 2v-95q-26 -8 -51 -8q-59 0 -95 34.5t-36 79.5q0 22 7.5 41t18 31t20.5 20.5t18 12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 425,
    d: "M93 537l-84 61q1 4 4 11t14.5 25t25.5 32t38 25t52 11q32 0 76.5 -29t60.5 -29q19 0 32.5 16t17.5 32l4 17l82 -65q-1 -4 -4 -11.5t-14 -25.5t-24.5 -32t-37 -25.5t-50.5 -11.5q-32 0 -76 28.5t-61 28.5q-19 0 -33 -14.5t-18 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 382,
    d: "M127 745l84 -54l-128 -177l-76 47zM296 745l84 -54l-128 -177l-76 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u0394",
    horizAdvX: 836,
    d: "M4 0l414 756l414 -756h-828zM191 114h454l-227 414z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 836,
    d: "M4 0l414 756l414 -756h-828zM191 114h454l-227 414z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u03A9",
    horizAdvX: 788,
    d: "M394 712q145 0 248 -98.5t103 -250.5q0 -83 -37.5 -147t-100.5 -102h113v-114h-259v114q72 25 117 94.5t45 154.5q0 103 -63.5 171t-165.5 68t-165.5 -68t-63.5 -171q0 -85 45 -154.5t117 -94.5v-114h-259v114h113q-63 38 -100.5 102t-37.5 147q0 152 103 250.5t248 98.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 788,
    d: "M394 712q145 0 248 -98.5t103 -250.5q0 -83 -37.5 -147t-100.5 -102h113v-114h-259v114q72 25 117 94.5t45 154.5q0 103 -63.5 171t-165.5 68t-165.5 -68t-63.5 -171q0 -85 45 -154.5t117 -94.5v-114h-259v114h113q-63 38 -100.5 102t-37.5 147q0 152 103 250.5t248 98.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 571,
    d: "M320 138v222h-90v-360h-120v360h-84v114h513v-114h-99v-207q0 -53 42 -53q10 0 18 2.5t11 5.5l3 2l39 -99q-39 -23 -88 -23q-55 0 -100 36t-45 114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 983,
    d: "M979 700l-276 -724l-210 525l-213 -525l-276 724h136l148 -420l159 420h99l156 -420l152 420h125zM347 913l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 768,
    d: "M4 474h134l98 -243l103 243h101l100 -243l102 243h122l-229 -498l-152 338l-150 -338zM239 694l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 983,
    d: "M979 700l-276 -724l-210 525l-213 -525l-276 724h136l148 -420l159 420h99l156 -420l152 420h125zM562 991l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 768,
    d: "M4 474h134l98 -243l103 243h101l100 -243l102 243h122l-229 -498l-152 338l-150 -338zM467 773l81 -79l-175 -168l-77 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 614,
    d: "M367 276v-276h-120v276l-239 424h132l171 -313l171 313h124zM140 893l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 557,
    d: "M20 -192l56 93q32 -31 63 -31t47.5 13.5t33.5 56.5l19 49l-231 485h133l160 -347l125 347h129l-230 -580q-54 -136 -178 -136q-32 0 -64 12.5t-47 25.5zM126 695l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 500,
    d: "M0 194v110h500v-110h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1000,
    d: "M0 194v110h1000v-110h-1000z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 186,
    d: "M40 454v246h106v-246h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 186,
    d: "M40 454v246h106v-246h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 186,
    d: "M40 -140v248h106v-248h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 400,
    d: "M60 452v248h106v-248h-106zM234 452v248h106v-248h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 400,
    d: "M60 452v248h106v-248h-106zM234 452v248h106v-248h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 400,
    d: "M60 -140v248h106v-248h-106zM234 -140v248h106v-248h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 520,
    d: "M63 412v114h136v174h120v-174h138v-114h-138v-492h-120v492h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 520,
    d: "M63 94v114h136v204h-136v114h136v174h120v-174h138v-114h-138v-204h138v-114h-138v-174h-120v174h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 500,
    d: "M106 350q0 59 42.5 101.5t101.5 42.5t101.5 -42.5t42.5 -101.5t-42.5 -101.5t-101.5 -42.5t-101.5 42.5t-42.5 101.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 1000,
    d: "M100 67q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM420 67q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM741 67q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1072,
    d: "M184 712q67 0 114.5 -46.5t47.5 -112.5t-47.5 -112.5t-114.5 -46.5t-114.5 46.5t-47.5 112.5t47.5 112.5t114.5 46.5zM184 471q34 0 57.5 23.5t23.5 58.5q0 34 -23.5 58t-57.5 24t-58 -23.5t-24 -58.5t23.5 -58.5t58.5 -23.5zM528 306q67 0 114.5 -46.5t47.5 -112.5 t-47.5 -112.5t-114.5 -46.5t-114.5 46.5t-47.5 112.5t47.5 112.5t114.5 46.5zM528 65q34 0 57.5 23.5t23.5 58.5q0 34 -23.5 58t-57.5 24t-58 -23.5t-24 -58.5t23.5 -58.5t58.5 -23.5zM888 306q67 0 114.5 -46.5t47.5 -112.5t-47.5 -112.5t-114.5 -46.5t-114.5 46.5 t-47.5 112.5t47.5 112.5t114.5 46.5zM888 65q34 0 57.5 23.5t23.5 58.5q0 34 -23.5 58t-57.5 24t-58 -23.5t-24 -58.5t23.5 -58.5t58.5 -23.5zM89 7l471 724l57 -39l-471 -724z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 322,
    d: "M9 245l183 236l82 -63l-138 -173l138 -173l-82 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 322,
    d: "M136 481l183 -236l-183 -236l-82 63l138 173l-138 173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 168,
    d: "M-180 7l471 724l57 -39l-471 -724z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 386,
    d: "M193 806q76 0 119.5 -58t43.5 -150t-43.5 -151t-119.5 -59t-119.5 59t-43.5 151t43.5 150t119.5 58zM193 473q38 0 55 36t17 89q0 52 -16.5 88t-55.5 36q-72 0 -72 -124q0 -125 72 -125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 386,
    d: "M4 472l208 328h98v-250h50v-78h-50v-78h-86v78h-220zM140 550h84v134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 383,
    d: "M345 530q0 -65 -47 -103.5t-108 -38.5q-32 0 -59 9.5t-43 22.5t-27 26t-15 22l-4 10l69 46q1 -2 2.5 -5.5t8 -12.5t14.5 -16t22.5 -12.5t31.5 -5.5q30 0 47.5 16.5t17.5 41.5q0 28 -20 45.5t-59 17.5q-25 0 -53 -7.5t-43 -14.5l-16 -7v236h275v-84h-185v-54q19 4 49 4 q58 0 100 -35t42 -101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 355,
    d: "M255 783l-72 -117q63 0 105.5 -41t42.5 -96q0 -56 -42 -98.5t-111 -42.5q-67 0 -108.5 42.5t-41.5 97.5q0 36 26 83l129 218zM178 587q-27 0 -45.5 -16t-18.5 -42t18.5 -42t45.5 -16q26 0 44.5 16t18.5 42t-18.5 42t-44.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 333,
    d: "M16 716v84h313l-219 -423l-76 41l157 298h-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 368,
    d: "M184 806q65 0 104 -33.5t39 -87.5q0 -24 -12.5 -44.5t-24.5 -28.5l-12 -8l6 -3t14 -9t17.5 -16.5t14 -26t6.5 -36.5q0 -54 -41.5 -89.5t-110.5 -35.5t-110.5 35.5t-41.5 89.5q0 20 6 36.5t14.5 26t17 16.5t14.5 10l6 2q-5 3 -13.5 9t-22 27t-13.5 46q0 54 38.5 87 t104.5 33zM184 468q28 0 45 13t17 34t-17 34t-45 13q-29 0 -45.5 -12.5t-16.5 -34.5q0 -21 17 -34t45 -13zM131 683q0 -43 53 -43t53 43t-53 43t-53 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 355,
    d: "M106 421l66 105q-63 0 -105.5 42t-42.5 97q0 56 42 98.5t111 42.5q67 0 108.5 -42.5t41.5 -97.5q0 -36 -26 -83l-123 -208zM177 607q27 0 45.5 16t18.5 42t-18.5 42t-45.5 16q-26 0 -44.5 -16t-18.5 -42t18.5 -42t44.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 386,
    d: "M193 319q76 0 119.5 -58t43.5 -150t-43.5 -151t-119.5 -59t-119.5 59t-43.5 151t43.5 150t119.5 58zM193 -14q38 0 55 36t17 89q0 52 -16.5 88t-55.5 36q-72 0 -72 -124q0 -125 72 -125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 323,
    d: "M8 182l158 131h85v-406h-93v289l-97 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 362,
    d: "M32 -93l152 184q1 2 13 16.5t17 22t11 21.5t6 26q0 25 -17.5 41t-45.5 16q-24 0 -40.5 -15t-21.5 -29l-5 -15l-79 27q1 5 4 13t14.5 28t26 35.5t42 28t59.5 12.5q74 0 114 -42t40 -98q0 -48 -32 -90l-75 -100h111v-82h-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 368,
    d: "M235 193q0 20 -15.5 32.5t-43.5 12.5q-22 0 -39.5 -11t-23.5 -21l-6 -11l-70 38q2 3 5 9t15 21t26.5 26t39.5 20.5t53 9.5q64 0 106.5 -33t42.5 -93q0 -24 -11.5 -42.5t-23.5 -24.5l-12 -7q2 -1 5.5 -2.5t13 -9t16.5 -16.5t13 -26t6 -37q0 -60 -45 -93.5t-109 -33.5 q-32 0 -59 10t-43 24t-27 28t-15 24l-4 10l74 41q2 -6 6 -15.5t23 -25t45 -15.5q31 0 47.5 13.5t16.5 32.5q0 49 -67 49h-22v70h15q27 0 47 11t20 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 386,
    d: "M4 -15l208 328h98v-250h50v-78h-50v-78h-86v78h-220zM140 63h84v134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 383,
    d: "M345 43q0 -65 -47 -103.5t-108 -38.5q-32 0 -59 9.5t-43 22.5t-27 26t-15 23l-4 9l69 46q1 -2 2.5 -5.5t8 -12.5t14.5 -16t22.5 -12.5t31.5 -5.5q30 0 47.5 16.5t17.5 41.5q0 28 -20 45.5t-59 17.5q-25 0 -53 -7t-43 -15l-16 -7v236h275v-84h-185v-54q19 4 49 4 q58 0 100 -35t42 -101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 355,
    d: "M255 296l-72 -117q63 0 105.5 -41t42.5 -96q0 -56 -42 -98.5t-111 -42.5q-67 0 -108.5 42.5t-41.5 97.5q0 36 26 83l129 218zM178 100q-27 0 -45.5 -16t-18.5 -42t18.5 -42t45.5 -16q26 0 44.5 16t18.5 42t-18.5 42t-44.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 333,
    d: "M16 229v84h313l-219 -423l-76 41l157 298h-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 368,
    d: "M184 319q65 0 104 -33.5t39 -87.5q0 -24 -12.5 -44.5t-24.5 -28.5l-12 -8l6 -3t14 -9t17.5 -16.5t14 -26t6.5 -36.5q0 -54 -41.5 -89.5t-110.5 -35.5t-110.5 35.5t-41.5 89.5q0 20 6 36.5t14.5 26t17 16.5t14.5 9l6 3q-5 3 -13.5 9t-22 27t-13.5 46q0 54 38.5 87 t104.5 33zM184 -19q28 0 45 13t17 34t-17 34t-45 13q-29 0 -45.5 -12.5t-16.5 -34.5q0 -21 17 -34t45 -13zM131 196q0 -43 53 -43t53 43t-53 43t-53 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 355,
    d: "M106 -66l66 105q-63 0 -105.5 42t-42.5 97q0 56 42 98.5t111 42.5q67 0 108.5 -42.5t41.5 -97.5q0 -36 -26 -83l-123 -208zM177 120q27 0 45.5 16t18.5 42t-18.5 42t-45.5 16q-26 0 -44.5 -16t-18.5 -42t18.5 -42t44.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    d: "M22 385v84h88q33 111 119.5 177t205.5 66q29 0 60.5 -6t48.5 -12l17 -6l-36 -102q-38 16 -90 16q-145 0 -200 -133h209v-84h-229q-3 -18 -3 -35q0 -24 2 -35h230v-84h-215q54 -131 200 -131q24 0 46.5 3.5t32.5 6.5l11 4l35 -102q-49 -24 -125 -24q-128 0 -210.5 65 t-116.5 178h-80v84h76q-1 11 -1 35q0 13 2 35h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numero",
    unicode: "\u2116",
    horizAdvX: 1110,
    d: "M733 228v106h314v-106h-314zM890 712q80 0 126 -54t46 -117t-46 -117t-126 -54t-126 54t-46 117t46 117t126 54zM819 541q0 -29 21 -50t50 -21t50 21t21 50t-21 50t-50 21t-50 -21t-21 -50zM74 700h108l350 -482v482h120v-700h-108l-350 481v-481h-120v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 805,
    d: "M124 330v287h-103v83h293v-83h-103v-287h-87zM359 700h84l115 -184l114 184h81v-370h-87v216l-110 -173l-110 173v-216h-87v370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 830,
    d: "M135 7l471 724l57 -39l-471 -724zM699 286q0 20 -15.5 32.5t-43.5 12.5q-14 0 -26.5 -4.5t-20 -10.5t-12.5 -12.5t-7 -11.5l-3 -4l-70 38q2 3 5 9t15 21t26.5 26t39.5 20.5t53 9.5q64 0 106.5 -33t42.5 -93q0 -24 -11.5 -42.5t-23.5 -25.5l-12 -6q2 -1 5.5 -2.5t13 -9 t16.5 -16.5t13 -26t6 -37q0 -60 -45 -93.5t-109 -33.5q-32 0 -59 10t-43 24t-27 28t-15 24l-4 10l74 41q2 -6 6 -15.5t23 -25t45 -15.5q31 0 47.5 13.5t16.5 32.5q0 49 -67 49h-22v70h15q27 0 47 11t20 35zM16 569l158 131h85v-406h-93v289l-97 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 817,
    d: "M22 294l152 184q1 2 13 16.5t17 22t11 21.5t6 26q0 25 -17.5 41t-45.5 16q-24 0 -40.5 -14.5t-21.5 -29.5l-5 -15l-79 27q1 5 4 13t14.5 28t26 35.5t42 28t59.5 12.5q74 0 114 -42t40 -98q0 -48 -32 -90l-75 -100h111v-82h-294zM702 286q0 20 -15.5 32.5t-43.5 12.5 q-14 0 -26.5 -4.5t-19.5 -10.5t-12.5 -12.5t-8.5 -11.5l-2 -4l-70 38q2 3 5 9t15 21t26.5 26t39.5 20.5t53 9.5q64 0 106.5 -33t42.5 -93q0 -24 -12 -42.5t-24 -25.5l-11 -6q2 -1 5.5 -2.5t13 -9t16.5 -16.5t13 -26t6 -37q0 -60 -45 -93.5t-109 -33.5q-32 0 -59 10t-43 24 t-27 28t-15 24l-4 10l74 41q2 -6 6 -15.5t23 -25t45 -15.5q31 0 47.5 13.5t16.5 32.5q0 49 -67 49h-22v70h15q27 0 47 11t20 35zM169 7l471 724l57 -39l-471 -724z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 830,
    d: "M16 569l158 131h85v-406h-93v289l-97 -80zM137 7l471 724l57 -39l-471 -724zM639 412q65 0 104 -33.5t39 -87.5q0 -24 -12 -44.5t-24 -28.5l-13 -8l6 -3t14 -9t17.5 -16.5t14 -26t6.5 -36.5q0 -54 -41.5 -89.5t-110.5 -35.5t-110.5 35.5t-41.5 89.5q0 20 6 36.5t14.5 26 t17 16.5t14.5 10l6 2q-5 3 -13.5 9t-22 27t-13.5 46q0 54 38.5 87t104.5 33zM639 74q28 0 45 13t17 34t-17 34t-45 13q-29 0 -45.5 -12.5t-16.5 -34.5q0 -21 17 -34t45 -13zM586 289q0 -43 53 -43t53 43t-53 43t-53 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 830,
    d: "M155 7l471 724l57 -39l-471 -724zM229 580q0 20 -15.5 32.5t-43.5 12.5q-14 0 -26.5 -4.5t-20 -10.5t-12.5 -12.5t-7 -11.5l-3 -4l-70 38q2 3 5 9t15 21t26.5 26t39.5 20.5t53 9.5q64 0 106.5 -33t42.5 -93q0 -24 -11.5 -42.5t-23.5 -25.5l-12 -6q2 -1 5.5 -2.5t13 -9 t16.5 -16.5t13 -26t6 -37q0 -60 -45 -93.5t-109 -33.5q-32 0 -59 10t-43 24t-27 28t-15 24l-4 10l74 41q2 -6 6 -15.5t23 -25t45 -15.5q31 0 47.5 13.5t16.5 32.5q0 49 -67 49h-22v70h15q27 0 47 11t20 35zM651 412q65 0 104 -33.5t39 -87.5q0 -24 -12 -44.5t-24 -28.5 l-13 -8l6 -3t14 -9t17.5 -16.5t14 -26t6.5 -36.5q0 -54 -41.5 -89.5t-110.5 -35.5t-110.5 35.5t-41.5 89.5q0 20 6 36.5t14.5 26t17 16.5t14.5 10l6 2q-5 3 -13.5 9t-22 27t-13.5 46q0 54 38.5 87t104.5 33zM651 74q28 0 45 13t17 34t-17 34t-45 13q-29 0 -45.5 -12.5 t-16.5 -34.5q0 -21 17 -34t45 -13zM598 289q0 -43 53 -43t53 43t-53 43t-53 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 830,
    d: "M332 430q0 -65 -47 -103.5t-108 -38.5q-32 0 -59 9.5t-43 22.5t-27 26t-15 22l-4 10l69 46q1 -2 2.5 -5.5t8 -12.5t14.5 -16t22.5 -12.5t31.5 -5.5q30 0 47.5 16.5t17.5 41.5q0 28 -20 45.5t-59 17.5q-25 0 -53 -7.5t-44 -14.5l-15 -7v236h275v-84h-185v-54q19 4 49 4 q58 0 100 -35t42 -101zM149 7l471 724l57 -39l-471 -724zM651 412q65 0 104 -33.5t39 -87.5q0 -24 -12 -44.5t-24 -28.5l-13 -8l6 -3t14 -9t17.5 -16.5t14 -26t6.5 -36.5q0 -54 -41.5 -89.5t-110.5 -35.5t-110.5 35.5t-41.5 89.5q0 20 6 36.5t14.5 26t17 16.5t14.5 10l6 2 q-5 3 -13.5 9t-22 27t-13.5 46q0 54 38.5 87t104.5 33zM651 74q28 0 45 13t17 34t-17 34t-45 13q-29 0 -45.5 -12.5t-16.5 -34.5q0 -21 17 -34t45 -13zM598 289q0 -43 53 -43t53 43t-53 43t-53 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 830,
    d: "M62 616v84h313l-219 -423l-76 41l157 298h-175zM114 7l471 724l57 -39l-471 -724zM645 412q65 0 104 -33.5t39 -87.5q0 -24 -12 -44.5t-24 -28.5l-13 -8l6 -3t14 -9t17.5 -16.5t14 -26t6.5 -36.5q0 -54 -41.5 -89.5t-110.5 -35.5t-110.5 35.5t-41.5 89.5q0 20 6 36.5 t14.5 26t17 16.5t14.5 10l6 2q-5 3 -13.5 9t-22 27t-13.5 46q0 54 38.5 87t104.5 33zM645 74q28 0 45 13t17 34t-17 34t-45 13q-29 0 -45.5 -12.5t-16.5 -34.5q0 -21 17 -34t45 -13zM592 289q0 -43 53 -43t53 43t-53 43t-53 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowleft",
    unicode: "\u2190",
    horizAdvX: 760,
    d: "M732 304v-110h-532l131 -143l-77 -74l-236 272l236 272l77 -74l-131 -143h532z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowup",
    unicode: "\u2191",
    horizAdvX: 598,
    d: "M354 0h-110v532l-143 -131l-74 77l272 236l272 -236l-74 -77l-143 131v-532z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowright",
    unicode: "\u2192",
    horizAdvX: 760,
    d: "M28 194v110h532l-131 143l77 74l236 -272l-236 -272l-77 74l131 143h-532z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowdown",
    unicode: "\u2193",
    horizAdvX: 598,
    d: "M244 700h110v-532l143 131l74 -77l-272 -236l-272 236l74 77l143 -131v532z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni21B3",
    unicode: "\u21B3",
    horizAdvX: 796,
    d: "M64 194v506h120v-396h412l-131 143l77 74l236 -272l-236 -272l-77 74l131 143h-532z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "carriagereturn",
    unicode: "\u21B5",
    horizAdvX: 796,
    d: "M732 700v-506h-532l131 -143l-77 -74l-236 272l236 272l77 -74l-131 -143h412v396h120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 544,
    d: "M272 486q57 0 99 -23q-22 37 -60 68t-76.5 49t-74 30.5t-57.5 17.5l-22 5l25 100q9 -1 24 -3.5t58.5 -15.5t83 -31t87.5 -53t82.5 -79t58.5 -112t24 -149v-13q0 -56 -14 -105.5t-43 -91.5t-79 -67t-116 -25q-109 0 -180.5 72t-71.5 177q0 106 71.5 177.5t180.5 71.5z M272 100q58 0 94 40t36 97t-36 97t-94 40t-94 -40t-36 -97t36 -97t94 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 707,
    d: "M635 700v-930h-120v816h-323v-816h-120v930h563z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 738,
    d: "M24 -230l325 466l-323 464h664v-114h-437l244 -350l-247 -352h440v-114h-666z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 520,
    d: "M35 190v112h450v-112h-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 625,
    d: "M318 257l224 703h114l-316 -980l-199 380h-111v114h176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 838,
    d: "M726 252q0 44 -30.5 72.5t-72.5 28.5q-18 0 -35.5 -6.5t-36 -21.5t-27.5 -23t-27 -28.5t-19 -21.5q1 -1 19 -21.5t27 -28.5t27.5 -23t36 -21.5t35.5 -6.5q42 0 72.5 28.5t30.5 72.5zM112 252q0 -44 30.5 -72.5t72.5 -28.5q18 0 35.5 6.5t36 21.5t27.5 23t27 28.5t19 21.5 q-1 1 -19 21.5t-27 28.5t-27.5 23t-36 21.5t-35.5 6.5q-42 0 -72.5 -28.5t-30.5 -72.5zM25 252q0 79 53 132q58 57 137 57q77 0 140 -63l64 -66l64 66q63 63 140 63q79 0 137 -57q53 -53 53 -132t-53 -132q-58 -57 -137 -57q-77 0 -140 63l-64 66l-64 -66q-63 -63 -140 -63 q-79 0 -137 57q-53 53 -53 132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 418,
    d: "M269 592v-663q0 -82 -46 -126.5t-115 -44.5q-27 0 -54 7.5t-40 14.5l-14 8l46 98q21 -16 46 -16q27 0 42 16.5t15 47.5v665q0 82 45.5 125.5t114.5 43.5q27 0 53.5 -7.5t39.5 -14.5l14 -8l-45 -98q-21 16 -46 16q-56 0 -56 -64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 520,
    d: "M117 276l-72 63q1 4 4 10t14 21t24.5 27t35.5 21.5t47 9.5q30 0 81 -25t68 -25q25 0 41.5 13.5t19.5 26.5l4 14l72 -65l-5 -10t-14.5 -22t-25.5 -28t-37.5 -22t-49.5 -10q-29 0 -81.5 24.5t-70.5 24.5q-20 0 -34 -12t-18 -24zM137 92l-72 63q1 4 4 10t14 21t24 27 t35 21.5t47 9.5q28 0 80 -25t70 -25q25 0 41.5 13.5t19.5 26.5l4 14l72 -65l-5 -10t-14.5 -22t-25.5 -28t-37.5 -22t-49.5 -10q-31 0 -82.5 24.5t-68.5 24.5q-20 0 -34 -12t-18 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 520,
    d: "M431 659l54 -31l-116 -219h103v-110h-162l-37 -70h199v-110h-257l-126 -238l-54 31l109 207h-102v110h161l37 70h-198v110h256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 520,
    d: "M19 0v102h462v-102h-462zM19 343v84l462 197v-115l-303 -124l303 -125v-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 520,
    d: "M504 102v-102h-462v102h462zM504 427v-84l-462 -198v115l303 125l-303 124v115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 488,
    d: "M244 169l121 188l-121 180l-124 -180zM2 357l242 355l242 -355l-242 -369z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "BALLOTBOX",
    unicode: "\u2610",
    horizAdvX: 844,
    d: "M82 0v700h680v-700h-680zM192 595v-490h460v490h-460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "BALLOTBOXWITHCHECK",
    unicode: "\u2611",
    horizAdvX: 844,
    d: "M192 595v-490h460v490h-460zM360 166l-117 184h106l57 -91l101 275h99l-143 -368h-103zM82 0v700h680v-700h-680z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "BALLOTBOXWITHX",
    unicode: "\u2612",
    horizAdvX: 844,
    d: "M82 0v700h680v-700h-680zM192 595v-490h460v490h-460zM423 285l-137 -150l-64 62l142 153l-141 152l64 62l136 -150l136 150l64 -62l-141 -152l142 -153l-64 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "heart",
    unicode: "\u2665",
    horizAdvX: 632,
    d: "M316 127l-240 239q-42 42 -42 101t42 100q41 41 100 41q58 0 99 -41q36 -36 41 -86q5 51 40 86q41 41 100 41q57 0 100 -41q42 -41 42 -100q0 -61 -42 -101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2709",
    unicode: "\u2709",
    horizAdvX: 844,
    d: "M20 0v700h804v-700h-804zM422 190l-292 309v-394h584v394zM180 595l242 -250l240 250h-482z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni270E",
    unicode: "\u270E",
    horizAdvX: 844,
    d: "M829 434l-383 -382l-371 -52l52 371l382 383zM446 207l231 231l-164 164l-231 -231zM246 117l120 15l-159 159l-15 -120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2717",
    unicode: "\u2717",
    horizAdvX: 844,
    d: "M772 637l-268 -288l268 -287l-88 -81l-262 280l-262 -280l-88 81l268 287l-268 288l88 81l262 -281l262 281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni27F5",
    unicode: "\u27F5",
    horizAdvX: 1000,
    d: "M968 304v-110h-768l131 -143l-77 -74l-236 272l236 272l77 -74l-131 -143h768z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni27F6",
    unicode: "\u27F6",
    horizAdvX: 1000,
    d: "M32 194v110h768l-131 143l77 74l236 -272l-236 -272l-77 74l131 143h-768z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    unicode: "\uF655",
    horizAdvX: 386,
    d: "M193 412q76 0 119.5 -58t43.5 -150t-43.5 -151t-119.5 -59t-119.5 59t-43.5 151t43.5 150t119.5 58zM193 79q38 0 55 36t17 89q0 52 -16.5 88t-55.5 36q-72 0 -72 -124q0 -125 72 -125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    unicode: "\uF656",
    horizAdvX: 323,
    d: "M8 275l158 131h85v-406h-93v289l-97 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    unicode: "\uF657",
    horizAdvX: 362,
    d: "M32 0l152 184q1 2 13 16.5t17 22t11 21.5t6 26q0 25 -17.5 41t-45.5 16q-24 0 -40.5 -14.5t-21.5 -29.5l-5 -15l-79 27q1 5 4 13t14.5 28t26 35.5t42 28t59.5 12.5q74 0 114 -42t40 -98q0 -48 -32 -90l-75 -100h111v-82h-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    unicode: "\uF658",
    horizAdvX: 368,
    d: "M235 286q0 20 -15.5 32.5t-43.5 12.5q-14 0 -26.5 -4.5t-20 -10.5t-12.5 -12.5t-7 -11.5l-3 -4l-70 38q2 3 5 9t15 21t26.5 26t39.5 20.5t53 9.5q64 0 106.5 -33t42.5 -93q0 -24 -11.5 -42.5t-23.5 -25.5l-12 -6q2 -1 5.5 -2.5t13 -9t16.5 -16.5t13 -26t6 -37 q0 -60 -45 -93.5t-109 -33.5q-32 0 -59 10t-43 24t-27 28t-15 24l-4 10l74 41q2 -6 6 -15.5t23 -25t45 -15.5q31 0 47.5 13.5t16.5 32.5q0 49 -67 49h-22v70h15q27 0 47 11t20 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    unicode: "\uF659",
    horizAdvX: 386,
    d: "M4 78l208 328h98v-250h50v-78h-50v-78h-86v78h-220zM140 156h84v134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    unicode: "\uF65A",
    horizAdvX: 383,
    d: "M345 136q0 -65 -47 -103.5t-108 -38.5q-32 0 -59 9.5t-43 22.5t-27 26t-15 22l-4 10l69 46q1 -2 2.5 -5.5t8 -12.5t14.5 -16t22.5 -12.5t31.5 -5.5q30 0 47.5 16.5t17.5 41.5q0 28 -20 45.5t-59 17.5q-25 0 -53 -7.5t-43 -14.5l-16 -7v236h275v-84h-185v-54q19 4 49 4 q58 0 100 -35t42 -101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    unicode: "\uF65B",
    horizAdvX: 355,
    d: "M255 389l-72 -117q63 0 105.5 -41t42.5 -96q0 -56 -42 -98.5t-111 -42.5q-67 0 -108.5 42.5t-41.5 97.5q0 36 26 83l129 218zM178 193q-27 0 -45.5 -16t-18.5 -42t18.5 -42t45.5 -16q26 0 44.5 16t18.5 42t-18.5 42t-44.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    unicode: "\uF65C",
    horizAdvX: 333,
    d: "M16 322v84h313l-219 -423l-76 41l157 298h-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    unicode: "\uF65D",
    horizAdvX: 368,
    d: "M184 412q65 0 104 -33.5t39 -87.5q0 -24 -12.5 -44.5t-24.5 -28.5l-12 -8l6 -3t14 -9t17.5 -16.5t14 -26t6.5 -36.5q0 -54 -41.5 -89.5t-110.5 -35.5t-110.5 35.5t-41.5 89.5q0 20 6 36.5t14.5 26t17 16.5t14.5 10l6 2q-5 3 -13.5 9t-22 27t-13.5 46q0 54 38.5 87 t104.5 33zM184 74q28 0 45 13t17 34t-17 34t-45 13q-29 0 -45.5 -12.5t-16.5 -34.5q0 -21 17 -34t45 -13zM131 289q0 -43 53 -43t53 43t-53 43t-53 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    unicode: "\uF65E",
    horizAdvX: 355,
    d: "M106 27l66 105q-63 0 -105.5 42t-42.5 97q0 56 42 98.5t111 42.5q67 0 108.5 -42.5t41.5 -97.5q0 -36 -26 -83l-123 -208zM177 213q27 0 45.5 16t18.5 42t-18.5 42t-45.5 16q-26 0 -44.5 -16t-18.5 -42t18.5 -42t44.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    unicode: "\uF661",
    horizAdvX: 386,
    d: "M193 706q76 0 119.5 -58t43.5 -150t-43.5 -151t-119.5 -59t-119.5 59t-43.5 151t43.5 150t119.5 58zM193 373q38 0 55 36t17 89q0 52 -16.5 88t-55.5 36q-72 0 -72 -124q0 -125 72 -125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    unicode: "\uF662",
    horizAdvX: 323,
    d: "M8 569l158 131h85v-406h-93v289l-97 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    unicode: "\uF663",
    horizAdvX: 362,
    d: "M32 294l152 184q1 2 13 16.5t17 22t11 21.5t6 26q0 25 -17.5 41t-45.5 16q-24 0 -40.5 -14.5t-21.5 -29.5l-5 -15l-79 27q1 5 4 13t14.5 28t26 35.5t42 28t59.5 12.5q74 0 114 -42t40 -98q0 -48 -32 -90l-75 -100h111v-82h-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    unicode: "\uF664",
    horizAdvX: 368,
    d: "M235 580q0 20 -15.5 32.5t-43.5 12.5q-14 0 -26.5 -4.5t-20 -10.5t-12.5 -12.5t-7 -11.5l-3 -4l-70 38q2 3 5 9t15 21t26.5 26t39.5 20.5t53 9.5q64 0 106.5 -33t42.5 -93q0 -24 -11.5 -42.5t-23.5 -25.5l-12 -6q2 -1 5.5 -2.5t13 -9t16.5 -16.5t13 -26t6 -37 q0 -60 -45 -93.5t-109 -33.5q-32 0 -59 10t-43 24t-27 28t-15 24l-4 10l74 41q2 -6 6 -15.5t23 -25t45 -15.5q31 0 47.5 13.5t16.5 32.5q0 49 -67 49h-22v70h15q27 0 47 11t20 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    unicode: "\uF665",
    horizAdvX: 386,
    d: "M4 372l208 328h98v-250h50v-78h-50v-78h-86v78h-220zM140 450h84v134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    unicode: "\uF666",
    horizAdvX: 383,
    d: "M345 430q0 -65 -47 -103.5t-108 -38.5q-32 0 -59 9.5t-43 22.5t-27 26t-15 22l-4 10l69 46q1 -2 2.5 -5.5t8 -12.5t14.5 -16t22.5 -12.5t31.5 -5.5q30 0 47.5 16.5t17.5 41.5q0 28 -20 45.5t-59 17.5q-25 0 -53 -7.5t-43 -14.5l-16 -7v236h275v-84h-185v-54q19 4 49 4 q58 0 100 -35t42 -101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    unicode: "\uF667",
    horizAdvX: 355,
    d: "M255 683l-72 -117q63 0 105.5 -41t42.5 -96q0 -56 -42 -98.5t-111 -42.5q-67 0 -108.5 42.5t-41.5 97.5q0 36 26 83l129 218zM178 487q-27 0 -45.5 -16t-18.5 -42t18.5 -42t45.5 -16q26 0 44.5 16t18.5 42t-18.5 42t-44.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    unicode: "\uF668",
    horizAdvX: 333,
    d: "M16 616v84h313l-219 -423l-76 41l157 298h-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    unicode: "\uF669",
    horizAdvX: 368,
    d: "M184 706q65 0 104 -33.5t39 -87.5q0 -24 -12.5 -44.5t-24.5 -28.5l-12 -8l6 -3t14 -9t17.5 -16.5t14 -26t6.5 -36.5q0 -54 -41.5 -89.5t-110.5 -35.5t-110.5 35.5t-41.5 89.5q0 20 6 36.5t14.5 26t17 16.5t14.5 10l6 2q-5 3 -13.5 9t-22 27t-13.5 46q0 54 38.5 87 t104.5 33zM184 368q28 0 45 13t17 34t-17 34t-45 13q-29 0 -45.5 -12.5t-16.5 -34.5q0 -21 17 -34t45 -13zM131 583q0 -43 53 -43t53 43t-53 43t-53 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    unicode: "\uF66A",
    horizAdvX: 355,
    d: "M106 321l66 105q-63 0 -105.5 42t-42.5 97q0 56 42 98.5t111 42.5q67 0 108.5 -42.5t41.5 -97.5q0 -36 -26 -83l-123 -208zM177 507q27 0 45.5 16t18.5 42t-18.5 42t-45.5 16q-26 0 -44.5 -16t-18.5 -42t18.5 -42t44.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at.alt",
    horizAdvX: 799,
    d: "M585 72l17 -37q-88 -47 -192 -47q-150 0 -256 106t-106 256t106 256t256 106q148 0 244.5 -101t96.5 -246q0 -66 -15 -112t-39.5 -67t-46.5 -29t-45 -8h-6q-80 2 -99 69l-5 -7.5t-14 -15.5t-24.5 -20t-35.5 -16t-46 -7q-55 0 -96 36t-41 93q0 53 43 89t97 36 q32 0 58.5 -8.5t37.5 -17.5l10 -8v17q0 38 -25.5 57.5t-58.5 19.5q-26 0 -52 -9t-39 -19l-13 -9l-40 72q7 5 20 13t51.5 21t75.5 13q74 0 120 -39.5t46 -105.5v-169q0 -22 11 -32.5t28 -10.5q100 0 100 174q0 129 -83 217t-215 88q-135 0 -227 -93t-92 -227 q0 -133 92.5 -226.5t226.5 -93.5q96 0 175 42zM400 232q26 0 47 10t29 20l8 11v29q-25 28 -84 28q-34 0 -53 -13.5t-19 -35.5t19 -35.5t53 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 573,
    d: "M402 474h111v-474h-111v62q-2 -3 -5 -8t-16 -18t-28 -22.5t-40 -17.5t-54 -8q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62zM393 166v142q-1 3 -4 7.5t-13 15.5t-22 20t-31.5 16t-41.5 7q-60 0 -95.5 -38.5t-35.5 -98.5 t35.5 -98.5t95.5 -38.5q34 0 62 16.5t39 33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "euro.alt",
    horizAdvX: 739,
    d: "M18 385v84h95q36 109 127 176t211 67q160 0 266 -117l-85 -75q-69 80 -181 80q-70 0 -126 -35.5t-84 -95.5h306v-84h-326q-9 -39 -3 -70h287v-84h-269q21 -59 76 -95t126 -36q56 0 107.5 24t84.5 64l78 -82q-105 -118 -270 -118q-123 0 -211.5 65t-116.5 178h-92v84h83 q0 24 2 70h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet.alt",
    horizAdvX: 500,
    d: "M40 350q0 87 61.5 148.5t148.5 61.5t148.5 -61.5t61.5 -148.5t-61.5 -148.5t-148.5 -61.5t-148.5 61.5t-61.5 148.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph.alt",
    horizAdvX: 589,
    d: "M24 513q0 77 55 132t132 55h304v-700h-102v598h-100v-598h-102v326q-77 0 -132 55t-55 132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fj",
    horizAdvX: 582,
    d: "M16 368v106h94v111q0 85 57 134t144 49q92 0 144.5 -49.5t52.5 -117.5v-11q0 -25 -18 -42t-43 -17t-42 17t-17 42v7q0 28 -21.5 45.5t-55.5 17.5q-33 0 -57 -22t-24 -63v-101h97v-106h-97v-368h-120v368h-94zM220 -211l44 100q27 -19 49 -19q15 0 25.5 2.5t23.5 11.5 t19.5 30t6.5 54v506h120v-517q0 -55 -17 -96t-44.5 -62t-56.5 -31t-58 -10q-60 0 -112 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ft",
    horizAdvX: 689,
    d: "M222 585v-111h166v129h120v-129h143v-106h-143v-193q0 -75 63 -75q12 0 24.5 4t18.5 8l7 5l43 -98q-45 -31 -114 -31q-71 0 -116.5 44.5t-45.5 121.5v214h-166v-368h-120v368h-86v106h86v114q0 91 51.5 135.5t118.5 44.5q29 0 55.5 -6t38.5 -12l11 -7l-45 -99 q-17 14 -48 14q-23 0 -42.5 -16t-19.5 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave.alt",
    horizAdvX: 573,
    d: "M402 474h111v-474h-111v62q-2 -3 -5 -8t-16 -18t-28 -22.5t-40 -17.5t-54 -8q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62zM393 166v142q-1 3 -4 7.5t-13 15.5t-22 20t-31.5 16t-41.5 7q-60 0 -95.5 -38.5t-35.5 -98.5 t35.5 -98.5t95.5 -38.5q34 0 62 16.5t39 33.5zM149 704l81 79l171 -174l-77 -73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute.alt",
    horizAdvX: 573,
    d: "M350 783l81 -79l-175 -168l-77 73zM402 474h111v-474h-111v62q-2 -3 -5 -8t-16 -18t-28 -22.5t-40 -17.5t-54 -8q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62zM393 166v142q-1 3 -4 7.5t-13 15.5t-22 20t-31.5 16t-41.5 7 q-60 0 -95.5 -38.5t-35.5 -98.5t35.5 -98.5t95.5 -38.5q34 0 62 16.5t39 33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex.alt",
    horizAdvX: 573,
    d: "M402 474h111v-474h-111v62q-2 -3 -5 -8t-16 -18t-28 -22.5t-40 -17.5t-54 -8q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62zM393 166v142q-1 3 -4 7.5t-13 15.5t-22 20t-31.5 16t-41.5 7q-60 0 -95.5 -38.5t-35.5 -98.5 t35.5 -98.5t95.5 -38.5q34 0 62 16.5t39 33.5zM106 606l186 134l186 -134l-66 -82l-120 91l-122 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde.alt",
    horizAdvX: 573,
    d: "M402 474h111v-474h-111v62q-2 -3 -5 -8t-16 -18t-28 -22.5t-40 -17.5t-54 -8q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62zM393 166v142q-1 3 -4 7.5t-13 15.5t-22 20t-31.5 16t-41.5 7q-60 0 -95.5 -38.5t-35.5 -98.5 t35.5 -98.5t95.5 -38.5q34 0 62 16.5t39 33.5zM157 554l-84 61q1 4 4 11t14.5 25t25.5 32t38 25t52 11q32 0 76.5 -29t60.5 -29q19 0 32.5 16.5t17.5 32.5l4 16l82 -65q-1 -4 -4 -11.5t-14 -25.5t-24.5 -32t-37 -25.5t-50.5 -11.5q-32 0 -76 28.5t-61 28.5q-19 0 -33 -14.5 t-18 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis.alt",
    horizAdvX: 573,
    d: "M402 474h111v-474h-111v62q-2 -3 -5 -8t-16 -18t-28 -22.5t-40 -17.5t-54 -8q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62zM393 166v142q-1 3 -4 7.5t-13 15.5t-22 20t-31.5 16t-41.5 7q-60 0 -95.5 -38.5t-35.5 -98.5 t35.5 -98.5t95.5 -38.5q34 0 62 16.5t39 33.5zM109 631q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56zM315 631q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring.alt",
    horizAdvX: 573,
    d: "M402 474h111v-474h-111v62q-2 -3 -5 -8t-16 -18t-28 -22.5t-40 -17.5t-54 -8q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62zM393 166v142q-1 3 -4 7.5t-13 15.5t-22 20t-31.5 16t-41.5 7q-60 0 -95.5 -38.5t-35.5 -98.5 t35.5 -98.5t95.5 -38.5q34 0 62 16.5t39 33.5zM164 648q0 49 36 84.5t86 35.5t86 -35.5t36 -84.5t-36 -84.5t-86 -35.5t-86 35.5t-36 84.5zM232 648q0 -22 16 -38t38 -16t38 16t16 38t-16 38t-38 16t-38 -16t-16 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron.alt",
    horizAdvX: 573,
    d: "M402 474h111v-474h-111v62q-2 -3 -5 -8t-16 -18t-28 -22.5t-40 -17.5t-54 -8q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62zM393 166v142q-1 3 -4 7.5t-13 15.5t-22 20t-31.5 16t-41.5 7q-60 0 -95.5 -38.5t-35.5 -98.5 t35.5 -98.5t95.5 -38.5q34 0 62 16.5t39 33.5zM125 567v108h322v-108h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve.alt",
    horizAdvX: 573,
    d: "M402 474h111v-474h-111v62q-2 -3 -5 -8t-16 -18t-28 -22.5t-40 -17.5t-54 -8q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62zM393 166v142q-1 3 -4 7.5t-13 15.5t-22 20t-31.5 16t-41.5 7q-60 0 -95.5 -38.5t-35.5 -98.5 t35.5 -98.5t95.5 -38.5q34 0 62 16.5t39 33.5zM107 712h108q0 -3 0.5 -8t4 -17t10 -21.5t21.5 -17.5t35 -8t35 7.5t21.5 18t10 21t3.5 17.5l1 8h108q0 -7 -1 -18t-10.5 -39t-26.5 -50t-54 -39.5t-87 -17.5t-87 17t-54 41t-26.5 48t-10.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek.alt",
    horizAdvX: 573,
    d: "M402 474h111v-474q-10 -3 -25 -9t-39.5 -26t-24.5 -43q0 -22 14 -35.5t37 -13.5q9 0 18.5 1.5t14.5 3.5l5 2v-95q-26 -8 -51 -8q-59 0 -95 35t-36 81q0 23 7.5 43.5t17.5 33.5t20.5 22.5t17.5 13.5l8 4v52q-2 -3 -5 -8t-16 -18t-28 -22.5t-40 -17.5t-54 -8 q-94 0 -162.5 71t-68.5 178t68.5 178t162.5 71q44 0 79.5 -18.5t49.5 -37.5l14 -18v62zM393 166v142q-1 3 -4 7.5t-13 15.5t-22 20t-31.5 16t-41.5 7q-60 0 -95.5 -38.5t-35.5 -98.5t35.5 -98.5t95.5 -38.5q34 0 62 16.5t39 33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum_tnum",
    d: "M291 712q65 0 116 -29.5t82 -80.5t47.5 -115t16.5 -137t-16.5 -137t-47.5 -115t-82 -80.5t-116 -29.5q-85 0 -146.5 51.5t-89.5 132t-28 178.5t28 178.5t89.5 132t146.5 51.5zM291 100q69 0 105.5 70.5t36.5 179.5t-36.5 179.5t-105.5 70.5q-70 0 -107 -70.5t-37 -179.5 t37 -179.5t107 -70.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum_tnum",
    d: "M73 504l246 196h99v-700h-120v540l-156 -124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum_tnum",
    d: "M48 0l257 326q3 3 18 21.5t22.5 30t19 31t16.5 40.5t5 43q0 44 -28.5 76t-75.5 32q-29 0 -52.5 -10.5t-36.5 -25.5t-21.5 -30t-11.5 -26l-3 -10l-107 39q2 7 6 19t22 42t41.5 53t67 42t95.5 19q108 0 166 -62.5t58 -155.5q0 -89 -61 -172l-161 -208h225v-114h-461z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum_tnum",
    d: "M384 502q0 42 -29.5 70t-75.5 28q-25 0 -47 -9t-34.5 -21t-21.5 -24.5t-12 -21.5l-4 -9l-104 49q2 6 6.5 16t23 35.5t41.5 45t64 35.5t88 16q98 0 162 -57.5t64 -152.5q0 -28 -9 -53.5t-21.5 -41.5t-25 -28.5t-21.5 -18.5l-9 -5q4 -1 11 -3.5t25 -14.5t31.5 -28t24.5 -46 t11 -68q0 -93 -69 -150t-173 -57q-55 0 -100 16.5t-71 40.5t-43.5 48t-23.5 41l-7 16l98 57q1 -4 4 -11.5t14.5 -26t26.5 -32.5t42.5 -25.5t59.5 -11.5q56 0 89 27t33 68q0 51 -36.5 75t-90.5 24h-50v110h38q121 0 121 98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum_tnum",
    d: "M-15 152l356 548h134v-436h77v-112h-77v-152h-120v152h-370zM181 264h176v271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum_tnum",
    d: "M545 230q0 -115 -74.5 -178.5t-174.5 -63.5q-52 0 -96 16.5t-70.5 40.5t-45 48t-26.5 41l-7 16l100 57q1 -4 4.5 -11.5t15.5 -26t27 -32.5t41 -25.5t57 -11.5q59 0 93.5 37t34.5 93q0 59 -37 94.5t-112 35.5q-43 0 -90 -19t-73 -38l-25 -19v416h440v-114h-320v-137 q39 21 99 21q100 0 169.5 -62t69.5 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum_tnum",
    d: "M407 670l-130 -211q13 3 24 3q108 0 172.5 -71t64.5 -166q0 -94 -68.5 -165.5t-176.5 -71.5t-176.5 71t-68.5 164q0 73 39 145l220 364zM293 350q-53 0 -88.5 -34.5t-35.5 -90.5t35.5 -90.5t88.5 -34.5t88.5 34.5t35.5 90.5t-35.5 90.5t-88.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum_tnum",
    d: "M69 586v114h500l-375 -724l-102 53l288 557h-311z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum_tnum",
    d: "M290 712q104 0 162 -59t58 -143q0 -41 -19.5 -75.5t-38.5 -48.5l-20 -14q4 -2 10.5 -5t23.5 -17t30 -31t23.5 -47t10.5 -66q0 -92 -65 -155t-175 -63t-175 63t-65 155q0 36 10 66t24.5 47.5t29 30t24.5 17.5l10 5q-3 2 -8.5 5.5t-19 16.5t-23.5 27.5t-18.5 38.5t-8.5 50 q0 84 58 143t162 59zM290 98q56 0 87.5 32t31.5 78t-31.5 77t-87.5 31t-87.5 -31t-31.5 -77t31.5 -78t87.5 -32zM391 509q0 42 -29 67.5t-72 25.5t-72 -25.5t-29 -67.5t29 -67.5t72 -25.5t72 25.5t29 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum_tnum",
    d: "M175 34l128 207q-13 -3 -24 -3q-104 0 -170.5 71.5t-66.5 165.5t68.5 165.5t176.5 71.5t176.5 -71t68.5 -164q0 -69 -40 -145l-217 -360zM287 350q53 0 88.5 34.5t35.5 90.5t-35.5 90.5t-88.5 34.5t-88.5 -34.5t-35.5 -90.5t35.5 -90.5t88.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.onum_pnum",
    horizAdvX: 554,
    d: "M277 486q108 0 181.5 -72t73.5 -177t-73.5 -177t-181.5 -72t-181.5 72t-73.5 177t73.5 177t181.5 72zM277 100q59 0 97 39t38 98t-38 98t-97 39t-97 -39t-38 -98t38 -98t97 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.onum_pnum",
    horizAdvX: 396,
    d: "M9 307l210 167h111v-474h-120v322l-131 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.onum_pnum",
    horizAdvX: 500,
    d: "M377 187l-72 -73h145v-114h-408l201 200q2 2 14 13.5t16 16t13 15.5t13 18.5t7.5 18t3.5 20.5q0 31 -23 51.5t-54 20.5q-28 0 -49.5 -17.5t-29.5 -34.5l-7 -18l-103 43q2 6 6 15t19.5 33t35 42.5t54 33.5t74.5 15q79 0 138 -51t59 -128q0 -34 -12 -60t-41 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.onum_pnum",
    horizAdvX: 543,
    d: "M368 283q0 39 -30 65t-74 26q-36 0 -64 -21t-38 -41l-9 -21l-103 50q2 6 7 15.5t23 34.5t40.5 44.5t61 35t82.5 15.5q92 0 158 -53t66 -150q0 -43 -18 -76.5t-36 -46.5l-18 -12q4 -1 9.5 -4t21 -14.5t27 -27t21 -44t9.5 -62.5q0 -94 -68.5 -150t-167.5 -56 q-50 0 -93 16.5t-68.5 39.5t-43.5 46t-25 40l-7 16l102 54q1 -4 4 -11t14 -24t25 -30t38.5 -24t53.5 -11q54 0 85 26t31 68q0 93 -116 93h-42v104h42q43 0 71.5 23.5t28.5 66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.onum_pnum",
    horizAdvX: 574,
    d: "M-4 0l348 474h133v-364h73v-110h-73v-198h-119v198h-362zM201 110h157v217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.onum_pnum",
    horizAdvX: 586,
    d: "M540 25q0 -76 -37.5 -131t-92.5 -79.5t-118 -24.5q-50 0 -93.5 16.5t-68.5 40t-43.5 47.5t-25.5 40l-7 17l99 56q1 -4 4.5 -11t15 -25.5t26 -32t39.5 -25t54 -11.5q56 0 92 31t36 92t-37.5 93.5t-96.5 32.5q-43 0 -92 -18.5t-76 -37.5l-27 -19v398h437v-120h-317v-108 q43 17 95 17q99 0 166.5 -62t67.5 -176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.onum_pnum",
    horizAdvX: 562,
    d: "M397 670l-130 -211q13 3 24 3q108 0 172.5 -71t64.5 -166q0 -94 -68.5 -165.5t-176.5 -71.5t-176.5 71t-68.5 164q0 73 39 145l220 364zM283 350q-53 0 -88.5 -34.5t-35.5 -90.5t35.5 -90.5t88.5 -34.5t88.5 34.5t35.5 90.5t-35.5 90.5t-88.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.onum_pnum",
    horizAdvX: 496,
    d: "M24 354v120h480l-353 -684l-109 58l262 506h-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.onum_pnum",
    horizAdvX: 576,
    d: "M288 712q104 0 162 -59t58 -143q0 -41 -19.5 -75.5t-38.5 -48.5l-20 -14q4 -2 10.5 -5t23.5 -17t30 -31t23.5 -47t10.5 -66q0 -92 -65 -155t-175 -63t-175 63t-65 155q0 36 10 66t24.5 47.5t29 30t24.5 17.5l10 5q-3 2 -8.5 5.5t-19 16.5t-23.5 27.5t-18.5 38.5t-8.5 50 q0 84 58 143t162 59zM288 98q56 0 87.5 32t31.5 78t-31.5 77t-87.5 31t-87.5 -31t-31.5 -77t31.5 -78t87.5 -32zM389 509q0 42 -29 67.5t-72 25.5t-72 -25.5t-29 -67.5t29 -67.5t72 -25.5t72 25.5t29 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.onum_pnum",
    horizAdvX: 556,
    d: "M184 -156l104 170q-5 -1 -18 -1q-102 0 -169 71t-67 165t68 165.5t175 71.5t174 -71t67 -164q0 -65 -42 -144l-194 -326zM276 124q52 0 87 35t35 90t-35 90t-87 35t-87 -35t-35 -90t35 -90t87 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.onum_tnum",
    d: "M290 486q108 0 181.5 -72t73.5 -177t-73.5 -177t-181.5 -72t-181.5 72t-73.5 177t73.5 177t181.5 72zM290 100q59 0 97 39t38 98t-38 98t-97 39t-97 -39t-38 -98t38 -98t97 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.onum_tnum",
    d: "M64 292l230 182h111v-474h-120v322l-151 -120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.onum_tnum",
    d: "M403 187l-72 -73h145v-114h-408l201 200q2 2 14 13.5t16 16t13 15.5t13 18.5t7.5 18t3.5 20.5q0 31 -23 51.5t-54 20.5q-28 0 -49.5 -17.5t-29.5 -34.5l-7 -18l-103 43q2 6 6 15t19.5 33t35 42.5t54 33.5t74.5 15q79 0 138 -51t59 -128q0 -34 -12 -60t-41 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.onum_tnum",
    d: "M372 283q0 39 -30 65t-74 26q-36 0 -64 -21t-38 -41l-9 -21l-103 50q2 6 7 15.5t23 34.5t40.5 44.5t61 35t82.5 15.5q92 0 158 -53t66 -150q0 -43 -18 -76.5t-36 -46.5l-18 -12q4 -1 9.5 -4t21 -14.5t27 -27t21 -44t9.5 -62.5q0 -94 -68.5 -150t-167.5 -56 q-50 0 -93 16.5t-68.5 39.5t-43.5 46t-25 40l-7 16l102 54q1 -4 4 -11t14 -24t25 -30t38.5 -24t53.5 -11q54 0 85 26t31 68q0 93 -116 93h-42v104h42q43 0 71.5 23.5t28.5 66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.onum_tnum",
    d: "M-14 0l348 474h133v-364h73v-110h-73v-198h-119v198h-362zM191 110h157v217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.onum_tnum",
    d: "M539 25q0 -76 -37.5 -131t-92.5 -79.5t-118 -24.5q-50 0 -93.5 16.5t-68.5 40t-43.5 47.5t-25.5 40l-7 17l99 56q1 -4 4.5 -11t15 -25.5t26 -32t39.5 -25t54 -11.5q56 0 92 31t36 92t-37.5 93.5t-96.5 32.5q-43 0 -92 -18.5t-76 -37.5l-27 -19v398h437v-120h-317v-108 q43 17 95 17q99 0 166.5 -62t67.5 -176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.onum_tnum",
    d: "M409 670l-130 -211q13 3 24 3q108 0 172.5 -71t64.5 -166q0 -94 -68.5 -165.5t-176.5 -71.5t-176.5 71t-68.5 164q0 73 39 145l220 364zM295 350q-53 0 -88.5 -34.5t-35.5 -90.5t35.5 -90.5t88.5 -34.5t88.5 34.5t35.5 90.5t-35.5 90.5t-88.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.onum_tnum",
    d: "M90 354v120h480l-353 -684l-109 58l262 506h-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.onum_tnum",
    d: "M290 712q104 0 162 -59t58 -143q0 -41 -19.5 -75.5t-38.5 -48.5l-20 -14q4 -2 10.5 -5t23.5 -17t30 -31t23.5 -47t10.5 -66q0 -92 -65 -155t-175 -63t-175 63t-65 155q0 36 10 66t24.5 47.5t29 30t24.5 17.5l10 5q-3 2 -8.5 5.5t-19 16.5t-23.5 27.5t-18.5 38.5t-8.5 50 q0 84 58 143t162 59zM290 98q56 0 87.5 32t31.5 78t-31.5 77t-87.5 31t-87.5 -31t-31.5 -77t31.5 -78t87.5 -32zM391 509q0 42 -29 67.5t-72 25.5t-72 -25.5t-29 -67.5t29 -67.5t72 -25.5t72 25.5t29 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.onum_tnum",
    d: "M196 -156l104 170q-5 -1 -18 -1q-102 0 -169 71t-67 165t68 165.5t175 71.5t174 -71t67 -164q0 -65 -42 -144l-194 -326zM288 124q52 0 87 35t35 90t-35 90t-87 35t-87 -35t-35 -90t35 -90t87 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Circle",
    horizAdvX: 844,
    d: "M60 350q0 150 105.5 256t255.5 106t255.5 -106t105.5 -256t-105.5 -256t-255.5 -106t-255.5 106t-105.5 256zM173 350q0 -103 72.5 -175.5t175.5 -72.5t175.5 72.5t72.5 175.5t-72.5 175.5t-175.5 72.5t-175.5 -72.5t-72.5 -175.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "CircleDotted",
    horizAdvX: 844,
    d: "M282 350q0 57 41 98.5t98 41.5t98.5 -41.5t41.5 -98.5t-41.5 -98t-98.5 -41q-58 0 -98.5 40.5t-40.5 98.5zM60 350q0 150 105.5 256t255.5 106t255.5 -106t105.5 -256t-105.5 -256t-255.5 -106t-255.5 106t-105.5 256zM173 350q0 -103 72.5 -175.5t175.5 -72.5 t175.5 72.5t72.5 175.5t-72.5 175.5t-175.5 72.5t-175.5 -72.5t-72.5 -175.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Trash",
    horizAdvX: 844,
    d: "M168 0l-133 700h774l-133 -700h-508zM354 590l7 -130h121l7 130h-135zM174 590l23 -130h114l-7 130h-130zM539 590l-7 -130h114l23 130h-130zM364 414l6 -126h104l6 126h-116zM205 414l22 -126h93l-6 126h-109zM530 414l-6 -126h92l22 126h-108zM372 242l7 -132h85l7 132 h-99zM521 242l-7 -132h71l23 132h-87zM235 242l23 -132h71l-7 132h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "EuropaType",
    horizAdvX: 776,
    d: "M619 194l24 -64q-32 -21 -92 -38q-8 13 -24 13q-12 0 -20.5 -8.5t-8.5 -20.5t8.5 -20.5t20.5 -8.5q11 0 19.5 8t9.5 19q43 12 94 38l24 -63q-12 -7 -33 -17t-82 -26.5t-118 -16.5q-21 30 -23 84q0 41 11 67q49 0 96.5 13.5t70.5 26.5zM211 408h363q-3 63 -52 109t-130 46 q-77 0 -126 -46t-55 -109zM391 712q153 0 245.5 -101.5t92.5 -264.5q0 -4 -3 -55h-514q9 -60 61.5 -102.5t133.5 -47.5q-11 -33 -11 -69q2 -50 21 -84h-6q-160 0 -262 105t-102 257t96 257t248 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period.tabular",
    d: "M211 67q0 33 23 56t56 23t56 -23t23 -56t-23 -56t-56 -23t-56 23t-23 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space.tabular"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "aogonek.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "abreve.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "amacron.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "aring.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "adieresis.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "atilde.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "acircumflex.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "aacute.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "agrave.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "a.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0161",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u015F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u015D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u015B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0153",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0151",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u014F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u014D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u011B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0119",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0117",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0115",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0113",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u010D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u010B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0109",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0107",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF8",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEA",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE8",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "s",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "o",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "e",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "c",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "g",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "d",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "aogonek.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "abreve.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "amacron.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "aring.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "adieresis.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "atilde.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "acircumflex.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "aacute.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "agrave.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "a.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0161",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u015F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u015D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u015B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0153",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0151",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u014F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u014D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u011B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0119",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0117",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0115",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0113",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u010D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u010B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0109",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0107",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF8",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEA",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE8",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "s",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "o",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "e",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "c",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "g",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "d",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1EF3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1E83",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1E81",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0177",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0175",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xFF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "w",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "v",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EF3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E83",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E82",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E81",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E80",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0177",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0175",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0174",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0166",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0164",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0162",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xFF",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "y",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "w",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "W",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "T",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "v",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ",",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xBB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "aogonek.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "abreve.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "amacron.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "aring.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "adieresis.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "atilde.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "acircumflex.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "aacute.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "agrave.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "a.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0151",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0119",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0117",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0115",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0113",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0109",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0107",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0105",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0104",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0103",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0102",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0101",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0100",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "q",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "g",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "d",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201D",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "'",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\"",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0104",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0102",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0100",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1EF2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0176",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u201E",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u201A",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "v",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ";",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ":",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "aogonek.alt",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "abreve.alt",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "amacron.alt",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "aring.alt",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "adieresis.alt",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "atilde.alt",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "acircumflex.alt",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "aacute.alt",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "agrave.alt",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "a.alt",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0177",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0173",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0171",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0169",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0157",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0155",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0151",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0150",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014F",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014D",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0133",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0122",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0120",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011B",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0119",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0117",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0115",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0113",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0108",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0106",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0105",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0104",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0103",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0102",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0101",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0100",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF8",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEE",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xED",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC0",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "i",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u203A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xBB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ";",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ":",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u203A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xBB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ";",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ";",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "-",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "v",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u201D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u2019",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "'",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\"",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201D",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2019",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "q",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "g",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "d",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "'",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\"",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "q",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "g",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "d",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u201D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u2019",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "'",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\"",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "-",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ",",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\u201D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\u2019",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "'",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\"",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u201D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u2019",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "aogonek.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "abreve.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "amacron.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "aring.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "adieresis.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "atilde.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "acircumflex.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "aacute.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "agrave.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "a.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0153",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0151",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u014F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u014D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u011B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0119",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0117",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0115",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0113",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u010D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u010B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0109",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0107",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0105",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0103",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0101",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF8",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xEB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xEA",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE8",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "c",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "a",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u201E",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u201A",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0153",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0151",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u014F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u014D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "o",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ",",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xBB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "V",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xBB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xBB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xBB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "V",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xBB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xBB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ",",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xBB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "V",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xBB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "V",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xBB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "V",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0109",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "q",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "g",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "d",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0137",
    u2: "q",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0137",
    u2: "g",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0137",
    u2: "d",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0138",
    u2: "q",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0138",
    u2: "g",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0138",
    u2: "d",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u201D",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "'",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\"",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u201D",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "'",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\"",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u201D",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "'",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\"",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "\u201D",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "'",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "\"",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u201D",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "'",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\"",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u201D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "-",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: ",",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "-",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: ",",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "-",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: ",",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "\u201D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "\u2019",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "'",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "\"",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "\u201D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "\u2019",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "'",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "\"",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "\u201D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "\u2019",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "'",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "\"",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "\u201D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "\u2019",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "'",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "\"",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u201E",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u201A",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "v",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: ";",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: ":",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: ".",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u201E",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u201A",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "v",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: ";",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: ":",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: ".",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u201E",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u201A",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ".",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\u203A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xBB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ";",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ".",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: ".",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "q",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ";",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ":",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ".",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "-",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0177",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0177",
    u2: ",",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "q",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ";",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ":",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ".",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "-",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "v",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "v",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\u203A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xBB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ";",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ".",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: ".",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\u203A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xBB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ";",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ".",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: ".",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "q",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ";",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ":",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ".",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "-",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF3",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF3",
    u2: ",",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "aogonek.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "abreve.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "amacron.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "aring.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "adieresis.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "atilde.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "acircumflex.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "aacute.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "agrave.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "a.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0161",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u015F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u015D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u015B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0153",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0151",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u014F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u014D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u011B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0119",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0117",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0115",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0113",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u010D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u010B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0109",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0107",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0102",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0100",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "s",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "o",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "e",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "c",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "q",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "g",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "d",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u1E83",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u1E82",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u1E81",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u1E80",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0175",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0174",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0166",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0164",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0162",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "w",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "W",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "T",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "v",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "V",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "aogonek.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "abreve.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "amacron.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "aring.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "adieresis.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "atilde.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "acircumflex.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "aacute.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "agrave.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "a.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0161",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u015F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u015D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u015B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0153",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0151",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u014F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u014D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u011B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0119",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0117",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0115",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0113",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u010D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u010B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0109",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0107",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0102",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0100",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF8",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEA",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE8",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "s",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "o",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "e",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "c",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "g",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "d",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u1E83",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u1E82",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u1E81",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u1E80",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0175",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0174",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0166",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0164",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0162",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "w",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "W",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "T",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "v",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u1E82",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u1E80",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0174",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0164",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0162",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0104",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0102",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0100",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "W",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "\u201D",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "\u2019",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "q",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "g",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "d",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "'",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "\"",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "agrave.alt",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aacute.alt",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "acircumflex.alt",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "atilde.alt",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "adieresis.alt",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aring.alt",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "amacron.alt",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "abreve.alt",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aogonek.alt",
    u2: "j",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum_pnum",
    u2: ".",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum_pnum",
    u2: ",",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.onum_pnum",
    u2: ".",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.onum_pnum",
    u2: ",",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "C,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcedilla,Omacron,Obreve,Ohungarumlaut",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "W,Wcircumflex,Wgrave,Wacute",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "Y,Ycircumflex,Ydieresis,Ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "y,ydieresis,ycircumflex,ygrave",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "W,Wcircumflex,Wgrave,Wacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "Y,Ycircumflex,Ydieresis,Ygrave",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcedilla,Lcaron,Ldot,Lslash",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcedilla,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcedilla,Lcaron,Ldot,Lslash",
    g2: "Y,Ycircumflex,Ydieresis,Ygrave",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcedilla,Lcaron,Ldot,Lslash",
    g2: "y,ydieresis,ycircumflex,ygrave",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "C,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcedilla,Omacron,Obreve,Ohungarumlaut",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "y,ydieresis,ycircumflex,ygrave",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "r,racute,rcedilla,rcaron",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "C,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcedilla,Omacron,Obreve,Ohungarumlaut",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "y,ydieresis,ycircumflex,ygrave",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "r,racute,rcedilla,rcaron",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "C,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcedilla,Omacron,Obreve,Ohungarumlaut",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,ij",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropaBold);
export default __webpack_public_path__ + "static/media/Europa-Bold.f39f6eb481cd3d7baae318283b10ee16.svg";
export { ForwardRef as ReactComponent };